/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type RetrieveVideoInput = {
  deviceIdClean: string,
  nodeIdClean: string,
  s3Key: string,
  startTime: string,
  endTime: string,
  timestreamRow?: string | null,
  ddbRow?: string | null,
  videoLength?: string | null,
};

export type updateTimestreamDataInput = {
  feedback: FeedbackType,
  mitigatedRisk?: string | null,
  model: string,
  customerId: string,
  locationId: string,
  nodeId: string,
  measureName: string,
  time: string,
};

export enum FeedbackType {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
}


export type createSecretsManagerSecretInput = {
  customerId: string,
  secretValue: string,
  secretType: SecretType,
};

export enum SecretType {
  ACCESS_KEY = "ACCESS_KEY",
  SECRET_ACCESS_KEY = "SECRET_ACCESS_KEY",
  BUCKET_NAME = "BUCKET_NAME",
  BUCKET_REGION = "BUCKET_REGION",
  CONTAINER_NAME = "CONTAINER_NAME",
  CONNECTION_STRING = "CONNECTION_STRING",
}


export type DeleteVideoInput = {
  groupId: string,
  videoId: string,
};

export type LeakFinderVideo = {
  __typename: "LeakFinderVideo",
  id: string,
  customerId: string,
  clientId: string,
  groupId: string,
  videoName: string,
  videoMethod: VideoMethod,
  windspeed: number,
  geometry: string,
  fov?: number | null,
  isVideoProcessed?: boolean | null,
  annotations?: string | null,
  sourceS3Key: string,
  modelOutputS3Key?: string | null,
  notes?: string | null,
  outputMeasurement?: number | null,
  videoState: VideoState,
};

export enum VideoMethod {
  DRONE = "DRONE",
  HANDHELD = "HANDHELD",
}


export enum VideoState {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  DONE = "DONE",
  ERROR = "ERROR",
}


export type UpdateVideoNotesInput = {
  groupId: string,
  videoId: string,
  notes?: string | null,
};

export type AddClientGroupInput = {
  customerId: string,
  clientId: string,
  groupName: string,
  groupId: string,
};

export type Group = {
  __typename: "Group",
  id: string,
  customerId: string,
  clientId: string,
  groupName: string,
  createdAt: number,
};

export type DeleteClientGroupInput = {
  clientId: string,
  groupId: string,
};

export type UpdateClientGroupInput = {
  clientId: string,
  groupId: string,
  groupName: string,
};

export type AddClientInput = {
  customerId: string,
  clientName: string,
};

export type Client = {
  __typename: "Client",
  id: string,
  clientName: string,
  customerId: string,
};

export type DeleteClientInput = {
  customerId: string,
  clientId: string,
};

export type UpdateClientInput = {
  id: string,
  customerId: string,
  clientName: string,
};

export type AddServiceInput = {
  nodeId: string,
  customerId: string,
  locationId: string,
  deviceId: string,
  timeZone: string,
  serviceType: string,
  configuration?: string | null,
};

export type Service = {
  __typename: "Service",
  nodeId?: string | null,
  customerId?: string | null,
  locationId?: string | null,
  deviceId?: string | null,
  serviceType?: string | null,
  configuration?: string | null,
  id?: string | null,
  healthData?: string | null,
  isRunning?: boolean | null,
  modelAlertSettingsId?: string | null,
  modelAlertSettings?: ModelAlertSettings | null,
};

export type ModelAlertSettings = {
  __typename: "ModelAlertSettings",
  id: string,
  serviceId: string,
  customerId: string,
  deviceId: string,
  timeZone: string,
  modelAlertParameters:  Array<ModelAlertParameters >,
};

export type ModelAlertParameters = {
  __typename: "ModelAlertParameters",
  objectType: ObjectTypeEnum,
  enabled: boolean,
  activeDays?: Array< DayOfWeekEnum > | null,
  schedules?:  Array<AlertSchedule > | null,
};

export enum ObjectTypeEnum {
  PEOPLE = "PEOPLE",
  VEHICLE = "VEHICLE",
  HARDHAT = "HARDHAT",
}


export enum DayOfWeekEnum {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
}


export type AlertSchedule = {
  __typename: "AlertSchedule",
  dayOfWeek: DayOfWeekEnum,
  dailyTimeRange:  Array<DailyTimeRange >,
};

export type DailyTimeRange = {
  __typename: "DailyTimeRange",
  startMinutesFromMidnight: number,
  endMinutesFromMidnight: number,
};

export type AddDeviceInput = {
  customerId: string,
  locationId: string,
  locationName?: string | null,
  name: string,
  nodeId: string,
  nodeName?: string | null,
  makeModelId: string,
  cameraIpAddress: string,
  deviceData?: string | null,
  skuNumber?: string | null,
  configurationName?: string | null,
  serialNumber?: string | null,
  componentSerialNumber?: string | null,
  onboardedAt?: number | null,
};

export type Device = {
  __typename: "Device",
  customerId: string,
  locationId: string,
  locationName?: string | null,
  id: string,
  name: string,
  status?: string | null,
  nodeId: string,
  nodeName?: string | null,
  makeModelId: string,
  cameraIpAddress?: string | null,
  deviceData: DeviceData,
  currentPosition?: CurrentPosition | null,
  healthData: DeviceHealthData,
  skuNumber?: string | null,
  configurationName?: string | null,
  serialNumber?: string | null,
  componentSerialNumber?: string | null,
  onboardedAt?: number | null,
};

export type DeviceData = {
  __typename: "DeviceData",
  hasPanTilt: boolean,
  hasRecordVideo: boolean,
  hasZoom: boolean,
  keyFrame: string,
  panTiltIP: string,
  panTiltType?: string | null,
  protocol: string,
  recentFrame: string,
  rtspHost: string,
  sourceVideo: string,
  signedUrlKeyFrame?: string | null,
  signedUrlRecentFrame?: string | null,
};

export type CurrentPosition = {
  __typename: "CurrentPosition",
  pan: string,
  tilt: string,
  zoom?: string | null,
};

export type DeviceHealthData = {
  __typename: "DeviceHealthData",
  lastAlive: string,
  isOnline: boolean,
};

export type AddCategoryInput = {
  customerId?: string | null,
  categoryName?: string | null,
};

export type Category = {
  __typename: "Category",
  id: string,
  categoryName: string,
  isAlertEnabled: boolean,
};

export type AddVideosInput = {
  videos: Array< VideoInput >,
  customerId: string,
};

export type VideoInput = {
  customerId: string,
  clientId: string,
  groupId: string,
  videoName: string,
  videoMethod: VideoMethod,
  windspeed: number,
  geometry: string,
  fov?: number | null,
  isVideoProcessed?: boolean | null,
  annotations?: string | null,
  sourceS3Key: string,
  modelOutputS3Key?: string | null,
  notes?: string | null,
  outputMeasurement?: number | null,
};

export type BatchDeleteVideosInput = {
  groupId: string,
  videoState: VideoState,
  id: string,
};

export type DeletedVideos = {
  __typename: "DeletedVideos",
  id: string,
  groupId: string,
};

export type BatchDeleteClientGroupsInput = {
  groupId: string,
  clientId: string,
};

export type AddLicensePlateInput = {
  customerId: string,
  licensePlate: string,
  categoryId: string,
  company?: string | null,
  driverName?: string | null,
};

export type LicensePlate = {
  __typename: "LicensePlate",
  id: string,
  categoryId: string,
  company?: string | null,
  driverName?: string | null,
  licensePlate: string,
};

export type UpdateLicensePlate = {
  customerId?: string | null,
  newCategoryId?: string | null,
  categoryId: string,
  licensePlateId: string,
  licensePlate: string,
  company?: string | null,
  driverName?: string | null,
};

export type DeleteLicensePlate = {
  categoryId: string,
  licensePlateId: string,
};

export type UpdateCategory = {
  customerId: string,
  categoryId: string,
  categoryName: string,
  isAlertEnabled: boolean,
};

export type DeleteCategory = {
  customerId?: string | null,
  categoryId?: string | null,
};

export type AddTagInput = {
  customerId: string,
  tagName: string,
};

export type Tag = {
  __typename: "Tag",
  id: string,
  tagName: string,
};

export type DeleteTagInput = {
  customerId: string,
  tagId: string,
};

export type BatchAddTagAssociationsInput = {
  customerId: string,
  arrayOfTags: Array< TagInput >,
  tagAssociation: AddTagAssociationInput,
};

export type TagInput = {
  id: string,
  associationId?: string | null,
  tagName: string,
};

export type AddTagAssociationInput = {
  associationType: TagAssociationType,
  associationId: string,
};

export enum TagAssociationType {
  ALL = "ALL",
  LOCATION = "LOCATION",
  NODE = "NODE",
}


export type TagOfAssociation = {
  __typename: "TagOfAssociation",
  id: string,
  associationId: string,
  tagName: string,
};

export type Node = {
  __typename: "Node",
  customerId?: string | null,
  locationId?: string | null,
  id?: string | null,
  nodeName?: string | null,
  nodeId?: string | null,
  level?: NodeLevel | null,
  referenceId?: string | null,
  devices?:  Array<Device > | null,
  serviceData?: string | null,
  deviceData?: string | null,
  onboardCommand?: string | null,
  tags?:  Array<Tag | null > | null,
  nodeIP?: string | null,
  isOnline?: boolean | null,
};

export enum NodeLevel {
  LOCATION = "LOCATION",
  NODE = "NODE",
  CUSTOMER = "CUSTOMER",
}


export type NodeIam = {
  __typename: "NodeIam",
  customerId?: string | null,
  locationId?: string | null,
  id?: string | null,
  nodeName?: string | null,
  nodeId?: string | null,
  level?: NodeLevel | null,
  referenceId?: string | null,
  devices?:  Array<Device > | null,
  serviceData?: string | null,
  deviceData?: string | null,
  onboardCommand?: string | null,
  tags?:  Array<Tag | null > | null,
  nodeIP?: string | null,
  isOnline?: boolean | null,
};

export type DTObjectInput = {
  customerId?: string | null,
  objectId: string,
  objectName: string,
  objectType: string,
  objectManufacturerName: string,
  filesInfo: Array< DTObjectFileInfoInput >,
};

export type DTObjectFileInfoInput = {
  originalFileName: string,
  contentType: string,
  useType: string,
};

export type DTObject = {
  __typename: "DTObject",
  id: string,
  version?: number | null,
  objectId: string,
  objectName: string,
  objectType: string,
  objectManufacturerName: string,
  isCustomerObject: boolean,
  filesInfo:  Array<DTObjectFileInfo >,
};

export type DTObjectFileInfo = {
  __typename: "DTObjectFileInfo",
  id: string,
  originalFileName: string,
  contentType: string,
  useType: string,
  key: string,
};

export type DeleteDTObjectInput = {
  customerId?: string | null,
  objectId: string,
};

export type UploadFileInput = {
  fileName?: string | null,
  contentType?: string | null,
};

export type DTFile = {
  __typename: "DTFile",
  key?: string | null,
  url?: string | null,
};

export type LoaderProgressInput = {
  jobId: string,
  percent: number,
  page?: number | null,
  rowsTotal?: number | null,
  message?: string | null,
};

export type LoaderProgress = {
  __typename: "LoaderProgress",
  jobId: string,
  percent: number,
  page?: number | null,
  rowsTotal?: number | null,
  message?: string | null,
};

export type AddDTProjectInput = {
  customerId: string,
  displayName: string,
  lastModifierUserName?: string | null,
  lastModificationDate?: string | null,
  withKMZLayer?: boolean | null,
  measurementSystem: string,
  usedObjects?: Array< string | null > | null,
};

export type DTProject = {
  __typename: "DTProject",
  id?: string | null,
  projectId?: string | null,
  customerId?: string | null,
  displayName?: string | null,
  lastModifierUserName?: string | null,
  lastModificationDate?: string | null,
  configURL?: string | null,
  withKMZLayer?: boolean | null,
  kmzLayerURL?: string | null,
  measurementSystem?: string | null,
};

export type UpdateDTProjectInput = {
  projectId: string,
  customerId: string,
  displayName: string,
  lastModifierUserName?: string | null,
  lastModificationDate?: string | null,
  withKMZLayer?: boolean | null,
  measurementSystem?: string | null,
  usedObjects?: Array< string | null > | null,
};

export type DeleteDTProjectInput = {
  projectId: string,
  customerId: string,
};

export type Shadow = {
  __typename: "Shadow",
  shadow?: string | null,
};

export type UpdateServiceInput = {
  configuration?: string | null,
  nodeId: string,
  serviceId: string,
};

export type DeleteServiceInput = {
  nodeId: string,
  serviceId: string,
  deviceId: string,
};

export type SetServiceStatusInput = {
  runStatus: boolean,
  nodeId: string,
  serviceId: string,
};

export type AddAlertSubscriptionInput = {
  entity: string,
  email: string,
};

export type AlertSubscription = {
  __typename: "AlertSubscription",
  entity?: string | null,
  email: string,
};

export type AddAlertWildCardSubscriptionInput = {
  wildCard: string,
  entity: string,
  email: string,
};

export type AlertWildCardSubscription = {
  __typename: "AlertWildCardSubscription",
  wildCard: string,
  entity: string,
  email: string,
};

export type AddZoneInput = {
  name: string,
  pan: string,
  tilt: string,
  deviceId: string,
  status: boolean,
  serviceId?: string | null,
  nodeId?: string | null,
  inspectTime?: string | null,
  keyFrame?: string | null,
  zoom?: string | null,
  shouldNotify?: boolean | null,
};

export type Zone = {
  __typename: "Zone",
  id: string,
  name: string,
  pan: string,
  tilt: string,
  deviceId: string,
  status: boolean,
  serviceId?: string | null,
  inspectTime?: string | null,
  keyFrame?: string | null,
  threshold?: ZoneThreshold | null,
  exclusions?: string | null,
  nodeId: string,
  alertData?: string | null,
  zoom?: string | null,
  shouldNotify?: boolean | null,
  signedUrlKeyFrame?: string | null,
};

export type ZoneThreshold = {
  __typename: "ZoneThreshold",
  id: string,
  name: string,
  value: number,
};

export type AddZoneThresholdInput = {
  name: string,
  value: number,
  customerId: string,
};

export type AnnotationInput = {
  id?: string | null,
  name: string,
  serviceId: string,
  nodeId: string,
  deviceId: string,
  zoneId?: string | null,
  polygon?: string | null,
  annotationType: AnnotationType,
  equipmentType?: string | null,
  annotateTanks?: boolean | null,
  tankNumber?: number | null,
  tankHeight?: number | null,
  bottomHidden?: number | null,
};

export enum AnnotationType {
  EXCLUSION_AREA = "EXCLUSION_AREA",
  EXCLUSION_AREA_STATIC = "EXCLUSION_AREA_STATIC",
  INCLUSION_AREA = "INCLUSION_AREA",
  INCLUSION_AREA_STATIC = "INCLUSION_AREA_STATIC",
  COMBUSTION_AREA = "COMBUSTION_AREA",
  COMBUSTION_AREA_STATIC = "COMBUSTION_AREA_STATIC",
  EQUIPMENT_TAG = "EQUIPMENT_TAG",
  SEARCH_AREA = "SEARCH_AREA",
  FOCUS_AREA_LF = "FOCUS_AREA_LF",
  TANK_LEVEL = "TANK_LEVEL",
}


export type Annotation = {
  __typename: "Annotation",
  id: string,
  serviceId: string,
  deviceId?: string | null,
  zoneId?: string | null,
  polygon?: string | null,
  annotationType: AnnotationType,
  equipmentType?: string | null,
  annotateTanks?: boolean | null,
  name: string,
  tankNumber?: number | null,
  tankHeight?: number | null,
  bottomHidden?: number | null,
};

export type UpdateZoneInput = {
  customerId: string,
  zoneId: string,
  deviceId: string,
  name?: string | null,
  pan?: string | null,
  tilt?: string | null,
  status?: boolean | null,
  inspectTime?: string | null,
  serviceId?: string | null,
  exclusions?: string | null,
  zoom?: string | null,
  shouldNotify?: boolean | null,
};

export type UpdateModelAlertSettingsInput = {
  id: string,
  serviceId: string,
  timeZone: string,
  modelAlertParameters: Array< ModelAlertParametersInput >,
};

export type ModelAlertParametersInput = {
  objectType: ObjectTypeEnum,
  enabled: boolean,
  activeDays?: Array< DayOfWeekEnum > | null,
  schedules?: Array< AlertScheduleInput > | null,
};

export type AlertScheduleInput = {
  dayOfWeek: DayOfWeekEnum,
  dailyTimeRange: Array< DailyTimeRangeInput >,
};

export type DailyTimeRangeInput = {
  startMinutesFromMidnight: number,
  endMinutesFromMidnight: number,
};

export type UpdateZoneThresholdValueInput = {
  customerId: string,
  deviceId: string,
  zoneId: string,
  value?: string | null,
};

export type UpdateZoneThresholdItemInput = {
  id: string,
  name: string,
  value: number,
};

export type addAlertEmailNotificationInput = {
  customerId: string,
  alertType: string,
  alertName: string,
  location?: string | null,
  model?: string | null,
  tag?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  additionalEmails?: Array< string | null > | null,
  additionalPhoneNumbers?: Array< string | null > | null,
  notificationSettingsJson?: string | null,
  node?: string | null,
  customService?: string | null,
  jsonObject?: string | null,
  subscribedLevelEntity?: string | null,
  createdBy: string,
};

export type Alert = {
  __typename: "Alert",
  id?: string | null,
  alertName?: string | null,
  alertType?: string | null,
  locationTag?: Array< string | null > | null,
  location?: string | null,
  model?: ModelType | null,
  email?: string | null,
  tag?: string | null,
  node?: string | null,
  customService?: string | null,
  jsonObject?: string | null,
  subscribedLevelEntity?: string | null,
  phoneNumber?: string | null,
  notificationSettingsJson?: string | null,
  createdBy: string,
};

export enum ModelType {
  gasleak = "gasleak",
  liquidleak = "liquidleak",
  smoke = "smoke",
  hardhat = "hardhat",
  fire = "fire",
  tlm = "tlm",
  agg = "agg",
  firesmoke = "firesmoke",
  peopleandvehicle = "peopleandvehicle",
  people = "people",
  vehicle = "vehicle",
  ss = "ss",
  safety = "safety",
  security = "security",
}


export type UpdateAlertInput = {
  customerId: string,
  alertType: string,
  alertName: string,
  notificationSettingsJson?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  location?: string | null,
  model?: string | null,
  additionalEmails?: Array< string | null > | null,
  additionalPhoneNumbers?: Array< string | null > | null,
  node?: string | null,
  customService?: string | null,
  jsonObject?: string | null,
};

export type UpdateAlertStatusInput = {
  customerId: string,
  id: string,
  notificationSettingsJson?: string | null,
};

export type UpdateAdminEmailAlertInput = {
  id: string,
  customerId: string,
  alertName: string,
  notificationSettingsJson?: string | null,
  location?: string | null,
  tag?: string | null,
  model?: string | null,
  subscribedLevelEntity?: string | null,
  additionalEmails?: Array< string | null > | null,
  additionalPhoneNumbers?: Array< string | null > | null,
};

export type UpdateAdminSystemAlertInput = {
  id: string,
  customerId: string,
  node?: string | null,
  customService?: string | null,
  jsonObject?: string | null,
};

export type UpdateUserAlertInput = {
  id: string,
  customerId: string,
  alertName: string,
  notificationSettingsJson?: string | null,
  phoneNumber?: string | null,
  location?: string | null,
  model?: string | null,
};

export type DeleteAlertInput = {
  id: string,
  customerId: string,
  alertName: string,
};

export type DeleteZoneInput = {
  deviceId: string,
  zoneId: string,
  serviceId: string,
};

export type DeleteAnnotationInput = {
  serviceId: string,
  zoneId?: string | null,
  id: string,
};

export type DeleteAllAnnotationsInput = {
  serviceId: string,
};

export type RemovedAnnotations = {
  __typename: "RemovedAnnotations",
  id?: string | null,
  zoneId?: string | null,
};

export type AddNodeInput = {
  customerExternalId: string,
  locationId: string,
  nodeName: string,
  nodeIP: string,
  referenceId?: string | null,
  level: NodeLevel,
  tags?: Array< AddTagInput | null > | null,
};

export type UpdateNodeInput = {
  nodeId: string,
  serviceData?: string | null,
  deviceData?: string | null,
};

export type UserSettingsInput = {
  defaultCameraFov?: number | null,
  defaultWindspeedUnit?: string | null,
  defaultVideoSpeed?: number | null,
  controlRoomRefreshMinutes?: number | null,
};

export type User = {
  __typename: "User",
  id: string,
  externalId: string,
  customer_id: string,
  firstName: string,
  lastName: string,
  email: string,
  user_role: string,
  userSettings?: string | null,
};

export type ChangeNodeStatusInput = {
  nodeId: string,
  action: string,
};

export type ProfileInput = {
  name: string,
  file?: string | null,
};

export type Profile = {
  __typename: "Profile",
  id: string,
  name?: string | null,
  file?: string | null,
};

export type EdgeClientMessageInput = {
  id: string,
  statusCode: number,
  topic: string,
  payload: string,
  payloadType: PayloadType,
  timestamp: string,
};

export enum PayloadType {
  DEVICE_PT_COORDS = "DEVICE_PT_COORDS",
  LF_VIDEO_PROCESS_STATUS = "LF_VIDEO_PROCESS_STATUS",
}


export type EdgeClientMessageResponse = {
  __typename: "EdgeClientMessageResponse",
  id: string,
  statusCode: number,
  topic: string,
  payload: string,
  payloadType: PayloadType,
  timestamp: string,
};

export type UpdateCustomerInput = {
  id: string,
  pointOfContact?: string | null,
  configuration?: string | null,
  allowLeakFinder?: AllowLeakFinder | null,
  aggAlertingData?: string | null,
  totalLeakFinderLimit?: number | null,
  devicePassword?: string | null,
};

export enum AllowLeakFinder {
  FULL_ACCESS = "FULL_ACCESS",
  TRIAL_ACCESS = "TRIAL_ACCESS",
  NONE = "NONE",
}


export type Customer = {
  __typename: "Customer",
  domains?: Array< string > | null,
  id: string,
  externalId: string,
  availableApps?: Array< string > | null,
  name?: string | null,
  pointOfContact?: string | null,
  totalLeakFinderLimit?: number | null,
  usageLeakFinderCount?: number | null,
  allowLeakFinder?: AllowLeakFinder | null,
  configuration?: string | null,
  auditCustomers?: string | null,
  aggAlertingData?: string | null,
  isQuantificationsDisabled?: boolean | null,
  devicePassword?: string | null,
};

export type LocationInput = {
  id?: string | null,
  customerId: string,
  customerExternalId: string,
  referenceId?: string | null,
  tags: Array< TagInput >,
  name?: string | null,
  locationData?: string | null,
  timeZone?: string | null,
};

export type Location = {
  __typename: "Location",
  id: string,
  name: string,
  referenceId?: string | null,
  locationData?: string | null,
  tags?:  Array<TagOfAssociation > | null,
  devices?:  Array<Device > | null,
  timeZone?: string | null,
};

export type UpdateLocationInput = {
  id?: string | null,
  customerId: string,
  tags: Array< TagInput >,
  tagsToDelete: Array< TagInput >,
  locationId?: string | null,
  referenceId?: string | null,
  name?: string | null,
  locationData?: string | null,
  timeZone?: string | null,
};

export type publishNodeInput = {
  nodeId: string,
  message: string,
};

export type publishNode = {
  __typename: "publishNode",
  nodeId: string,
  message: string,
};

export type HumanValidationEvent = {
  __typename: "HumanValidationEvent",
  id: string,
  customerId: string,
  locationId: string,
  nodeId: string,
  serviceId: string,
  data?: string | null,
  validationState?: ValidationState | null,
  validated_by?: string | null,
  explanation?: string | null,
  eventTime: string,
  audited_by?: string | null,
  transitionInfo?: string | null,
  auditorsExplanation?: string | null,
};

export enum ValidationState {
  PENDING = "PENDING",
  IN_VALIDATION = "IN_VALIDATION",
  REAL = "REAL",
  NOT_REAL = "NOT_REAL",
  EXPIRED = "EXPIRED",
}


export type ValidateEventInput = {
  customerId: string,
  real: boolean,
  eventId: string,
  eventTime: string,
  explanation?: string | null,
  auditorsExplanation?: string | null,
  eventType?: ModelType | null,
};

export type Domain = {
  __typename: "Domain",
  customerId?: string | null,
};

export type AddDevicesTemplateInput = {
  name: string,
  numberOfNodes: number,
  templateData: string,
};

export type DevicesTemplate = {
  __typename: "DevicesTemplate",
  id: string,
  name: string,
  numberOfNodes: number,
  templateData: string,
};

export type UpdateDeviceInput = {
  customerId: string,
  deviceId: string,
  name?: string | null,
  nodeId?: string | null,
  nodeName?: string | null,
  makeModelId?: string | null,
  cameraIpAddress?: string | null,
  locationName?: string | null,
  deviceData?: string | null,
  skuNumber?: string | null,
  configurationName?: string | null,
  serialNumber?: string | null,
  componentSerialNumber?: string | null,
};

export type AddDeviceMakeInput = {
  name: string,
  model: string,
  type: string,
  rtspTemplate: string,
  hasPanTilt: boolean,
  hasZoom?: boolean | null,
  modelsToRun: Array< string | null >,
};

export type DeviceMake = {
  __typename: "DeviceMake",
  id: string,
  name: string,
  model: string,
  type: string,
  rtspTemplate: string,
  defaultUserPwd?: string | null,
  hasPanTilt: boolean,
  hasZoom?: boolean | null,
  modelsToRun: Array< string | null >,
  deviceTypeShortName?: string | null,
};

export type UpdateDeviceMakeInput = {
  id: string,
  name: string,
  model: string,
  type: string,
  rtspTemplate: string,
  hasPanTilt: boolean,
  hasZoom?: boolean | null,
  modelsToRun: Array< string | null >,
};

export type AddSKUInput = {
  skuNumber: string,
  configurationName: string,
  category?: string | null,
  nodeCount: number,
  defaultIp?: string | null,
  skuDataConfigurations: string,
};

export type SKU = {
  __typename: "SKU",
  id: string,
  skuNumber: string,
  configurationName: string,
  category?: string | null,
  nodeCount: number,
  skuDataConfigurations: string,
  createdAt?: number | null,
  defaultIp?: string | null,
};

export type NodeMessage = {
  __typename: "NodeMessage",
  internalNodeId: string,
  message?: string | null,
};

export type NodeFile = {
  __typename: "NodeFile",
  internalNodeId: string,
  downloadURL: string,
  file?: string | null,
};

export type DeviceIam = {
  __typename: "DeviceIam",
  customerId: string,
  locationId: string,
  locationName?: string | null,
  id: string,
  name: string,
  status?: string | null,
  nodeId: string,
  nodeName?: string | null,
  makeModelId: string,
  cameraIpAddress?: string | null,
  deviceData: DeviceDataIam,
  currentPosition?: CurrentPosition | null,
  healthData: DeviceHealthDataIam,
};

export type DeviceDataIam = {
  __typename: "DeviceDataIam",
  hasPanTilt: boolean,
  hasRecordVideo: boolean,
  hasZoom: boolean,
  keyFrame: string,
  panTiltIP: string,
  panTiltType?: string | null,
  protocol: string,
  recentFrame: string,
  rtspHost: string,
  sourceVideo: string,
  signedUrlKeyFrame?: string | null,
  signedUrlRecentFrame?: string | null,
};

export type DeviceHealthDataIam = {
  __typename: "DeviceHealthDataIam",
  isOnline: boolean,
  lastAlive: string,
};

export type UpdateServiceHealthInput = {
  id: string,
  nodeId?: string | null,
  customerId?: string | null,
  locationId?: string | null,
  deviceId?: string | null,
  serviceType?: string | null,
  configuration?: string | null,
  healthData?: string | null,
  isRunning?: boolean | null,
};

export type ServiceIam = {
  __typename: "ServiceIam",
  nodeId?: string | null,
  customerId?: string | null,
  locationId?: string | null,
  deviceId?: string | null,
  serviceType?: string | null,
  configuration?: string | null,
  id?: string | null,
  healthData?: string | null,
  isRunning?: boolean | null,
};

export type SetExpectedOnlineInput = {
  customerId: string,
  entityId: string,
  isExpectedOnline?: boolean | null,
  reason?: string | null,
  locationId?: string | null,
};

export type SetExpectedOnlineResult = {
  __typename: "SetExpectedOnlineResult",
  updatedCount: number,
};

export type UpdateHealthLeafMetadataInput = {
  pk1: string,
  sk: string,
  reason?: string | null,
  assignedWatcher?: string | null,
};

export type UpdateHealthLeafMetadataResult = {
  __typename: "UpdateHealthLeafMetadataResult",
  updatedCount: number,
};

export type DeleteHealthLeafInput = {
  healthLeafPartitionKey?: string | null,
  healthLeafSortKey?: string | null,
};

export type DeleteHealthLeafResult = {
  __typename: "DeleteHealthLeafResult",
  deleted: boolean,
  pk1: string,
  sk: string,
};

export type PaginatedHealthLeaves = {
  __typename: "PaginatedHealthLeaves",
  items:  Array<HealthLeaf >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedResponse = {
  __typename: "PaginatedResponse",
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedServices = {
  __typename: "PaginatedServices",
  items:  Array<Service >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedCustomers = {
  __typename: "PaginatedCustomers",
  items:  Array<Customer >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedNodes = {
  __typename: "PaginatedNodes",
  items:  Array<Node >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedDevices = {
  __typename: "PaginatedDevices",
  items:  Array<Device >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedDevicesMakes = {
  __typename: "PaginatedDevicesMakes",
  items:  Array<DeviceMake >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedDeviceTemplates = {
  __typename: "PaginatedDeviceTemplates",
  items:  Array<DevicesTemplate | null >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedLocations = {
  __typename: "PaginatedLocations",
  items:  Array<Location >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedZones = {
  __typename: "PaginatedZones",
  items:  Array<Zone >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedZonesThresholds = {
  __typename: "PaginatedZonesThresholds",
  items:  Array<ZoneThreshold >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedAnnotations = {
  __typename: "PaginatedAnnotations",
  items:  Array<Annotation >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedSubscriptionsForEmail = {
  __typename: "PaginatedSubscriptionsForEmail",
  items:  Array<AlertSubscription >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedAllEmailsForSubscriptionEntity = {
  __typename: "PaginatedAllEmailsForSubscriptionEntity",
  items:  Array<AlertSubscription >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedAlertSubscriptions = {
  __typename: "PaginatedAlertSubscriptions",
  items:  Array<AlertSubscription >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedWildCardsForSubscriptionEntity = {
  __typename: "PaginatedWildCardsForSubscriptionEntity",
  items:  Array<AlertWildCardSubscription >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedHumanValidationEvents = {
  __typename: "PaginatedHumanValidationEvents",
  items:  Array<HumanValidationEvent >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedSKUs = {
  __typename: "PaginatedSKUs",
  items:  Array<SKU | null >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedLicensePlates = {
  __typename: "PaginatedLicensePlates",
  items:  Array<LicensePlate >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedCategories = {
  __typename: "PaginatedCategories",
  items:  Array<Category >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedTags = {
  __typename: "PaginatedTags",
  items:  Array<Tag >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedTagAssociations = {
  __typename: "PaginatedTagAssociations",
  items:  Array<TagOfAssociation >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedUsers = {
  __typename: "PaginatedUsers",
  items:  Array<User | null >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedAlerts = {
  __typename: "PaginatedAlerts",
  items:  Array<Alert | null >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedLeakFinderVideos = {
  __typename: "PaginatedLeakFinderVideos",
  items:  Array<LeakFinderVideo >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedDTProjects = {
  __typename: "PaginatedDTProjects",
  items:  Array<DTProject | null >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedClients = {
  __typename: "PaginatedClients",
  items:  Array<Client >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedModelAlertSettings = {
  __typename: "PaginatedModelAlertSettings",
  items:  Array<ModelAlertSettings >,
  nextToken?: string | null,
  limit?: number | null,
};

export type PaginatedGroups = {
  __typename: "PaginatedGroups",
  items:  Array<Group >,
  nextToken?: string | null,
  limit?: number | null,
};

export type HealthLeaf = {
  __typename: "HealthLeaf",
  pk: string,
  sk: string,
  entity: string,
  customerId: string,
  locationId?: string | null,
  locationName?: string | null,
  nodeId?: string | null,
  nodeName?: string | null,
  deviceId?: string | null,
  deviceName?: string | null,
  serviceType?: string | null,
  isOnline: boolean,
  lastSeenEpochMs?: number | null,
  isExpectedOnline?: boolean | null,
  author?: string | null,
  reason?: string | null,
  toggleTimestamp?: string | null,
  assignedWatcher?: string | null,
};

export type GetTimelapseVideoInput = {
  date: string,
  deviceIdClean: string,
  nodeIdClean: string,
};

export type GetSignedUrlActionInput = {
  objectKey: string,
  bucketKey: string,
  operation?: signedUrlActions | null,
  contentType?: string | null,
};

export enum signedUrlActions {
  getObject = "getObject",
  putObject = "putObject",
  deleteObject = "deleteObject",
}


export type GetGroupsByClientInput = {
  customerId: string,
  clientId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetGroupByClientIdInput = {
  clientId: string,
  groupId: string,
};

export type GetClientsByCustomerInput = {
  customerId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllVideosByGroupInput = {
  groupId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllVideosByStateInput = {
  customerId: string,
  videoState: VideoState,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllVideosByClientInput = {
  clientId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetLicensePlatesByCustomerInput = {
  customerId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetCategoriesByCustomerInput = {
  customerId?: string | null,
  categoryName?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetTagsByCustomerInput = {
  customerId: string,
  nextToken?: string | null,
};

export type GetTagAssociationsInput = {
  customerId: string,
  associationId?: string | null,
  associationType: TagAssociationType,
  nextToken?: string | null,
  limit?: number | null,
};

export type GetCategoryInput = {
  customerId: string,
  categoryId: string,
};

export type GetClientInput = {
  customerId: string,
  clientId: string,
};

export type GetServiceInput = {
  customerId?: string | null,
  serviceId?: string | null,
  locationId?: string | null,
  nodeId?: string | null,
};

export type GetModelAlertSettingsInput = {
  modelAlertSettingsSelectionKey: SelectionKey,
  serviceId?: string | null,
  deviceId?: string | null,
  customerId?: string | null,
  id?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export enum SelectionKey {
  serviceId = "serviceId",
  deviceId = "deviceId",
  customerId = "customerId",
  id = "id",
  keys = "keys",
}


export type TimestreamDataInput = {
  customerId: string,
  model: string,
  dateRange?: string | null,
  locations?: Array< string > | null,
  companyName?: string | null,
  categoryName?: string | null,
  licensePlate?: string | null,
  skipGeneratingSignedUrl?: boolean | null,
  limit?: number | null,
  offset?: number | null,
  nextToken?: string | null,
};

export type StatisticsDataInput = {
  customerId: string,
  eventType: eventType,
  date?: string | null,
  deviceName?: string | null,
  locations?: Array< string > | null,
  timePeriod?: TimePeriod | null,
  dateRange?: DateRangeInput | null,
  models?: Array< ModelType | null > | null,
  timeframeDays?: number | null,
  jobId?: string | null,
};

export enum eventType {
  allAlerts = "allAlerts",
  gasVolumes = "gasVolumes",
  deviceOverview = "deviceOverview",
  PPEInfractions = "PPEInfractions",
  visitors = "visitors",
  totalSiteCounts = "totalSiteCounts",
  nodeUptime = "nodeUptime",
  deviceUptime = "deviceUptime",
  serviceUptime = "serviceUptime",
  bandwidthFailures = "bandwidthFailures",
  locGasLeak = "locGasLeak",
  locLiquidLeak = "locLiquidLeak",
  falsePositiveEvents = "falsePositiveEvents",
  feedbackDetails = "feedbackDetails",
  confirmedLeakDetections = "confirmedLeakDetections",
  facilityRealtimeUptime = "facilityRealtimeUptime",
}


export enum TimePeriod {
  ALL_TIME = "ALL_TIME",
  ONE_MONTH = "ONE_MONTH",
  ONE_WEEK = "ONE_WEEK",
  ONE_DAY = "ONE_DAY",
}


export type DateRangeInput = {
  from?: string | null,
  to?: string | null,
};

export type S3FilesInput = {
  date?: string | null,
  deviceIdClean: string,
  nodeIdClean: string,
};

export type CustomerCountersType = {
  __typename: "CustomerCountersType",
  id: string,
  totalLeakFinderLimit?: number | null,
  usageLeakFinderCount?: number | null,
  allowLeakFinder?: AllowLeakFinder | null,
};

export type Form = {
  __typename: "Form",
  id?: string | null,
  customerId?: string | null,
  fields?:  Array<Field | null > | null,
};

export type Field = {
  __typename: "Field",
  name: string,
  type: string,
  entries?: Array< string | null > | null,
  itemToQuery?: string | null,
};

export type GetZonesThresholdsByCustomerInput = {
  customerId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetZoneThresholdInput = {
  customerId: string,
  thresholdId: string,
};

export type GetAnnotationsInput = {
  customerId?: string | null,
  serviceId?: string | null,
  zoneId?: string | null,
  deviceId?: string | null,
  nodeId?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RetrieveVideoMutationVariables = {
  input?: RetrieveVideoInput | null,
};

export type RetrieveVideoMutation = {
  retrieveVideo?: string | null,
};

export type UpdateTimestreamDataMutationVariables = {
  input: updateTimestreamDataInput,
};

export type UpdateTimestreamDataMutation = {
  updateTimestreamData?: string | null,
};

export type DeleteFolderFromS3MutationVariables = {
  folderPath: string,
};

export type DeleteFolderFromS3Mutation = {
  deleteFolderFromS3?: string | null,
};

export type CreateSecretsManagerSecretMutationVariables = {
  input: createSecretsManagerSecretInput,
};

export type CreateSecretsManagerSecretMutation = {
  createSecretsManagerSecret?: string | null,
};

export type DeleteVideoMutationVariables = {
  input: DeleteVideoInput,
};

export type DeleteVideoMutation = {
  deleteVideo?:  {
    __typename: "LeakFinderVideo",
    id: string,
    customerId: string,
    clientId: string,
    groupId: string,
    videoName: string,
    videoMethod: VideoMethod,
    windspeed: number,
    geometry: string,
    fov?: number | null,
    isVideoProcessed?: boolean | null,
    annotations?: string | null,
    sourceS3Key: string,
    modelOutputS3Key?: string | null,
    notes?: string | null,
    outputMeasurement?: number | null,
    videoState: VideoState,
  } | null,
};

export type UpdateVideoNotesMutationVariables = {
  input: UpdateVideoNotesInput,
};

export type UpdateVideoNotesMutation = {
  updateVideoNotes:  {
    __typename: "LeakFinderVideo",
    id: string,
    customerId: string,
    clientId: string,
    groupId: string,
    videoName: string,
    videoMethod: VideoMethod,
    windspeed: number,
    geometry: string,
    fov?: number | null,
    isVideoProcessed?: boolean | null,
    annotations?: string | null,
    sourceS3Key: string,
    modelOutputS3Key?: string | null,
    notes?: string | null,
    outputMeasurement?: number | null,
    videoState: VideoState,
  },
};

export type AddClientGroupMutationVariables = {
  input?: AddClientGroupInput | null,
};

export type AddClientGroupMutation = {
  addClientGroup?:  {
    __typename: "Group",
    id: string,
    customerId: string,
    clientId: string,
    groupName: string,
    createdAt: number,
  } | null,
};

export type DeleteClientGroupMutationVariables = {
  input?: DeleteClientGroupInput | null,
};

export type DeleteClientGroupMutation = {
  deleteClientGroup?:  {
    __typename: "Group",
    id: string,
    customerId: string,
    clientId: string,
    groupName: string,
    createdAt: number,
  } | null,
};

export type UpdateClientGroupMutationVariables = {
  input?: UpdateClientGroupInput | null,
};

export type UpdateClientGroupMutation = {
  updateClientGroup?:  {
    __typename: "Group",
    id: string,
    customerId: string,
    clientId: string,
    groupName: string,
    createdAt: number,
  } | null,
};

export type AddClientMutationVariables = {
  input: AddClientInput,
};

export type AddClientMutation = {
  addClient?:  {
    __typename: "Client",
    id: string,
    clientName: string,
    customerId: string,
  } | null,
};

export type DeleteClientMutationVariables = {
  input: DeleteClientInput,
};

export type DeleteClientMutation = {
  deleteClient?:  {
    __typename: "Client",
    id: string,
    clientName: string,
    customerId: string,
  } | null,
};

export type UpdateClientMutationVariables = {
  input: UpdateClientInput,
};

export type UpdateClientMutation = {
  updateClient?:  {
    __typename: "Client",
    id: string,
    clientName: string,
    customerId: string,
  } | null,
};

export type BatchAddServicesMutationVariables = {
  input: Array< AddServiceInput >,
};

export type BatchAddServicesMutation = {
  batchAddServices?:  Array< {
    __typename: "Service",
    nodeId?: string | null,
    customerId?: string | null,
    locationId?: string | null,
    deviceId?: string | null,
    serviceType?: string | null,
    configuration?: string | null,
    id?: string | null,
    healthData?: string | null,
    isRunning?: boolean | null,
    modelAlertSettingsId?: string | null,
    modelAlertSettings?:  {
      __typename: "ModelAlertSettings",
      id: string,
      serviceId: string,
      customerId: string,
      deviceId: string,
      timeZone: string,
      modelAlertParameters:  Array< {
        __typename: "ModelAlertParameters",
        objectType: ObjectTypeEnum,
        enabled: boolean,
        activeDays?: Array< DayOfWeekEnum > | null,
        schedules?:  Array< {
          __typename: "AlertSchedule",
          dayOfWeek: DayOfWeekEnum,
          dailyTimeRange:  Array< {
            __typename: "DailyTimeRange",
            startMinutesFromMidnight: number,
            endMinutesFromMidnight: number,
          } >,
        } > | null,
      } >,
    } | null,
  } | null > | null,
};

export type BatchAddDevicesMutationVariables = {
  input: Array< AddDeviceInput >,
};

export type BatchAddDevicesMutation = {
  batchAddDevices?:  Array< {
    __typename: "Device",
    customerId: string,
    locationId: string,
    locationName?: string | null,
    id: string,
    name: string,
    status?: string | null,
    nodeId: string,
    nodeName?: string | null,
    makeModelId: string,
    cameraIpAddress?: string | null,
    deviceData:  {
      __typename: "DeviceData",
      hasPanTilt: boolean,
      hasRecordVideo: boolean,
      hasZoom: boolean,
      keyFrame: string,
      panTiltIP: string,
      panTiltType?: string | null,
      protocol: string,
      recentFrame: string,
      rtspHost: string,
      sourceVideo: string,
      signedUrlKeyFrame?: string | null,
      signedUrlRecentFrame?: string | null,
    },
    currentPosition?:  {
      __typename: "CurrentPosition",
      pan: string,
      tilt: string,
      zoom?: string | null,
    } | null,
    healthData:  {
      __typename: "DeviceHealthData",
      lastAlive: string,
      isOnline: boolean,
    },
    skuNumber?: string | null,
    configurationName?: string | null,
    serialNumber?: string | null,
    componentSerialNumber?: string | null,
    onboardedAt?: number | null,
  } | null > | null,
};

export type BatchAddCategoryMutationVariables = {
  input: Array< AddCategoryInput >,
};

export type BatchAddCategoryMutation = {
  batchAddCategory:  Array< {
    __typename: "Category",
    id: string,
    categoryName: string,
    isAlertEnabled: boolean,
  } >,
};

export type BatchAddVideosMutationVariables = {
  input?: AddVideosInput | null,
};

export type BatchAddVideosMutation = {
  batchAddVideos:  Array< {
    __typename: "LeakFinderVideo",
    id: string,
    customerId: string,
    clientId: string,
    groupId: string,
    videoName: string,
    videoMethod: VideoMethod,
    windspeed: number,
    geometry: string,
    fov?: number | null,
    isVideoProcessed?: boolean | null,
    annotations?: string | null,
    sourceS3Key: string,
    modelOutputS3Key?: string | null,
    notes?: string | null,
    outputMeasurement?: number | null,
    videoState: VideoState,
  } >,
};

export type BatchDeleteVideosMutationVariables = {
  input: Array< BatchDeleteVideosInput >,
};

export type BatchDeleteVideosMutation = {
  batchDeleteVideos:  Array< {
    __typename: "DeletedVideos",
    id: string,
    groupId: string,
  } >,
};

export type BatchDeleteClientGroupsMutationVariables = {
  input: Array< BatchDeleteClientGroupsInput >,
};

export type BatchDeleteClientGroupsMutation = {
  batchDeleteClientGroups:  Array< {
    __typename: "Group",
    id: string,
    customerId: string,
    clientId: string,
    groupName: string,
    createdAt: number,
  } >,
};

export type BatchAddLicensePlateMutationVariables = {
  input: Array< AddLicensePlateInput >,
};

export type BatchAddLicensePlateMutation = {
  batchAddLicensePlate:  Array< {
    __typename: "LicensePlate",
    id: string,
    categoryId: string,
    company?: string | null,
    driverName?: string | null,
    licensePlate: string,
  } >,
};

export type AddLicensePlateMutationVariables = {
  input: AddLicensePlateInput,
};

export type AddLicensePlateMutation = {
  addLicensePlate?:  {
    __typename: "LicensePlate",
    id: string,
    categoryId: string,
    company?: string | null,
    driverName?: string | null,
    licensePlate: string,
  } | null,
};

export type UpdateLicensePlateWithNewCategoryMutationVariables = {
  input: UpdateLicensePlate,
};

export type UpdateLicensePlateWithNewCategoryMutation = {
  updateLicensePlateWithNewCategory?:  {
    __typename: "LicensePlate",
    id: string,
    categoryId: string,
    company?: string | null,
    driverName?: string | null,
    licensePlate: string,
  } | null,
};

export type DeleteLicensePlateMutationVariables = {
  input: DeleteLicensePlate,
};

export type DeleteLicensePlateMutation = {
  deleteLicensePlate?:  {
    __typename: "LicensePlate",
    id: string,
    categoryId: string,
    company?: string | null,
    driverName?: string | null,
    licensePlate: string,
  } | null,
};

export type AddCategoryMutationVariables = {
  input: AddCategoryInput,
};

export type AddCategoryMutation = {
  addCategory?:  {
    __typename: "Category",
    id: string,
    categoryName: string,
    isAlertEnabled: boolean,
  } | null,
};

export type UpdateCategoryMutationVariables = {
  input: UpdateCategory,
};

export type UpdateCategoryMutation = {
  updateCategory?:  {
    __typename: "Category",
    id: string,
    categoryName: string,
    isAlertEnabled: boolean,
  } | null,
};

export type DeleteCategoryMutationVariables = {
  input: DeleteCategory,
};

export type DeleteCategoryMutation = {
  deleteCategory?:  {
    __typename: "Category",
    id: string,
    categoryName: string,
    isAlertEnabled: boolean,
  } | null,
};

export type AddTagMutationVariables = {
  input: AddTagInput,
};

export type AddTagMutation = {
  addTag:  {
    __typename: "Tag",
    id: string,
    tagName: string,
  },
};

export type DeleteTagMutationVariables = {
  input: DeleteTagInput,
};

export type DeleteTagMutation = {
  deleteTag:  {
    __typename: "Tag",
    id: string,
    tagName: string,
  },
};

export type BatchAddTagAssociationsMutationVariables = {
  input?: BatchAddTagAssociationsInput | null,
};

export type BatchAddTagAssociationsMutation = {
  batchAddTagAssociations:  Array< {
    __typename: "TagOfAssociation",
    id: string,
    associationId: string,
    tagName: string,
  } >,
};

export type SyncShadowMutationVariables = {
  nodeId: string,
};

export type SyncShadowMutation = {
  syncShadow?:  {
    __typename: "Node",
    customerId?: string | null,
    locationId?: string | null,
    id?: string | null,
    nodeName?: string | null,
    nodeId?: string | null,
    level?: NodeLevel | null,
    referenceId?: string | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    serviceData?: string | null,
    deviceData?: string | null,
    onboardCommand?: string | null,
    tags?:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } | null > | null,
    nodeIP?: string | null,
    isOnline?: boolean | null,
  } | null,
};

export type SendNodeConfigIamMutationVariables = {
  nodeId: string,
};

export type SendNodeConfigIamMutation = {
  sendNodeConfigIam?:  {
    __typename: "NodeIam",
    customerId?: string | null,
    locationId?: string | null,
    id?: string | null,
    nodeName?: string | null,
    nodeId?: string | null,
    level?: NodeLevel | null,
    referenceId?: string | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    serviceData?: string | null,
    deviceData?: string | null,
    onboardCommand?: string | null,
    tags?:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } | null > | null,
    nodeIP?: string | null,
    isOnline?: boolean | null,
  } | null,
};

export type AddDTObjectMutationVariables = {
  input: DTObjectInput,
};

export type AddDTObjectMutation = {
  addDTObject?:  {
    __typename: "DTObject",
    id: string,
    version?: number | null,
    objectId: string,
    objectName: string,
    objectType: string,
    objectManufacturerName: string,
    isCustomerObject: boolean,
    filesInfo:  Array< {
      __typename: "DTObjectFileInfo",
      id: string,
      originalFileName: string,
      contentType: string,
      useType: string,
      key: string,
    } >,
  } | null,
};

export type AddCustomerDTObjectMutationVariables = {
  input: DTObjectInput,
};

export type AddCustomerDTObjectMutation = {
  addCustomerDTObject?:  {
    __typename: "DTObject",
    id: string,
    version?: number | null,
    objectId: string,
    objectName: string,
    objectType: string,
    objectManufacturerName: string,
    isCustomerObject: boolean,
    filesInfo:  Array< {
      __typename: "DTObjectFileInfo",
      id: string,
      originalFileName: string,
      contentType: string,
      useType: string,
      key: string,
    } >,
  } | null,
};

export type UpdateCustomerDTObjectMutationVariables = {
  input: DTObjectInput,
};

export type UpdateCustomerDTObjectMutation = {
  updateCustomerDTObject?:  {
    __typename: "DTObject",
    id: string,
    version?: number | null,
    objectId: string,
    objectName: string,
    objectType: string,
    objectManufacturerName: string,
    isCustomerObject: boolean,
    filesInfo:  Array< {
      __typename: "DTObjectFileInfo",
      id: string,
      originalFileName: string,
      contentType: string,
      useType: string,
      key: string,
    } >,
  } | null,
};

export type DeleteCustomerDTObjectMutationVariables = {
  input: DeleteDTObjectInput,
};

export type DeleteCustomerDTObjectMutation = {
  deleteCustomerDTObject?:  {
    __typename: "DTObject",
    id: string,
    version?: number | null,
    objectId: string,
    objectName: string,
    objectType: string,
    objectManufacturerName: string,
    isCustomerObject: boolean,
    filesInfo:  Array< {
      __typename: "DTObjectFileInfo",
      id: string,
      originalFileName: string,
      contentType: string,
      useType: string,
      key: string,
    } >,
  } | null,
};

export type UploadDTFileMutationVariables = {
  customerId?: string | null,
  objectId: string,
  file: UploadFileInput,
};

export type UploadDTFileMutation = {
  uploadDTFile?:  {
    __typename: "DTFile",
    key?: string | null,
    url?: string | null,
  } | null,
};

export type UploadDTFilesMutationVariables = {
  customerId?: string | null,
  objectId: string,
  files: Array< UploadFileInput >,
};

export type UploadDTFilesMutation = {
  uploadDTFiles?:  Array< {
    __typename: "DTFile",
    key?: string | null,
    url?: string | null,
  } | null > | null,
};

export type ReportLoaderProgressMutationVariables = {
  event: LoaderProgressInput,
};

export type ReportLoaderProgressMutation = {
  reportLoaderProgress?:  {
    __typename: "LoaderProgress",
    jobId: string,
    percent: number,
    page?: number | null,
    rowsTotal?: number | null,
    message?: string | null,
  } | null,
};

export type AddDTProjectMutationVariables = {
  input: AddDTProjectInput,
};

export type AddDTProjectMutation = {
  addDTProject?:  {
    __typename: "DTProject",
    id?: string | null,
    projectId?: string | null,
    customerId?: string | null,
    displayName?: string | null,
    lastModifierUserName?: string | null,
    lastModificationDate?: string | null,
    configURL?: string | null,
    withKMZLayer?: boolean | null,
    kmzLayerURL?: string | null,
    measurementSystem?: string | null,
  } | null,
};

export type UpdateDTProjectMutationVariables = {
  input: UpdateDTProjectInput,
};

export type UpdateDTProjectMutation = {
  updateDTProject?:  {
    __typename: "DTProject",
    id?: string | null,
    projectId?: string | null,
    customerId?: string | null,
    displayName?: string | null,
    lastModifierUserName?: string | null,
    lastModificationDate?: string | null,
    configURL?: string | null,
    withKMZLayer?: boolean | null,
    kmzLayerURL?: string | null,
    measurementSystem?: string | null,
  } | null,
};

export type DeleteDTProjectMutationVariables = {
  input: DeleteDTProjectInput,
};

export type DeleteDTProjectMutation = {
  deleteDTProject?:  {
    __typename: "DTProject",
    id?: string | null,
    projectId?: string | null,
    customerId?: string | null,
    displayName?: string | null,
    lastModifierUserName?: string | null,
    lastModificationDate?: string | null,
    configURL?: string | null,
    withKMZLayer?: boolean | null,
    kmzLayerURL?: string | null,
    measurementSystem?: string | null,
  } | null,
};

export type UpdateShadowNodeMutationVariables = {
  thingName?: string | null,
  shadowName?: string | null,
  payload?: string | null,
};

export type UpdateShadowNodeMutation = {
  updateShadowNode?:  {
    __typename: "Shadow",
    shadow?: string | null,
  } | null,
};

export type AddServiceMutationVariables = {
  input: AddServiceInput,
};

export type AddServiceMutation = {
  addService?:  {
    __typename: "Service",
    nodeId?: string | null,
    customerId?: string | null,
    locationId?: string | null,
    deviceId?: string | null,
    serviceType?: string | null,
    configuration?: string | null,
    id?: string | null,
    healthData?: string | null,
    isRunning?: boolean | null,
    modelAlertSettingsId?: string | null,
    modelAlertSettings?:  {
      __typename: "ModelAlertSettings",
      id: string,
      serviceId: string,
      customerId: string,
      deviceId: string,
      timeZone: string,
      modelAlertParameters:  Array< {
        __typename: "ModelAlertParameters",
        objectType: ObjectTypeEnum,
        enabled: boolean,
        activeDays?: Array< DayOfWeekEnum > | null,
        schedules?:  Array< {
          __typename: "AlertSchedule",
          dayOfWeek: DayOfWeekEnum,
          dailyTimeRange:  Array< {
            __typename: "DailyTimeRange",
            startMinutesFromMidnight: number,
            endMinutesFromMidnight: number,
          } >,
        } > | null,
      } >,
    } | null,
  } | null,
};

export type UpdateServiceMutationVariables = {
  input: UpdateServiceInput,
};

export type UpdateServiceMutation = {
  updateService?:  {
    __typename: "Service",
    nodeId?: string | null,
    customerId?: string | null,
    locationId?: string | null,
    deviceId?: string | null,
    serviceType?: string | null,
    configuration?: string | null,
    id?: string | null,
    healthData?: string | null,
    isRunning?: boolean | null,
    modelAlertSettingsId?: string | null,
    modelAlertSettings?:  {
      __typename: "ModelAlertSettings",
      id: string,
      serviceId: string,
      customerId: string,
      deviceId: string,
      timeZone: string,
      modelAlertParameters:  Array< {
        __typename: "ModelAlertParameters",
        objectType: ObjectTypeEnum,
        enabled: boolean,
        activeDays?: Array< DayOfWeekEnum > | null,
        schedules?:  Array< {
          __typename: "AlertSchedule",
          dayOfWeek: DayOfWeekEnum,
          dailyTimeRange:  Array< {
            __typename: "DailyTimeRange",
            startMinutesFromMidnight: number,
            endMinutesFromMidnight: number,
          } >,
        } > | null,
      } >,
    } | null,
  } | null,
};

export type DeleteServiceMutationVariables = {
  input: DeleteServiceInput,
};

export type DeleteServiceMutation = {
  deleteService?:  {
    __typename: "Service",
    nodeId?: string | null,
    customerId?: string | null,
    locationId?: string | null,
    deviceId?: string | null,
    serviceType?: string | null,
    configuration?: string | null,
    id?: string | null,
    healthData?: string | null,
    isRunning?: boolean | null,
    modelAlertSettingsId?: string | null,
    modelAlertSettings?:  {
      __typename: "ModelAlertSettings",
      id: string,
      serviceId: string,
      customerId: string,
      deviceId: string,
      timeZone: string,
      modelAlertParameters:  Array< {
        __typename: "ModelAlertParameters",
        objectType: ObjectTypeEnum,
        enabled: boolean,
        activeDays?: Array< DayOfWeekEnum > | null,
        schedules?:  Array< {
          __typename: "AlertSchedule",
          dayOfWeek: DayOfWeekEnum,
          dailyTimeRange:  Array< {
            __typename: "DailyTimeRange",
            startMinutesFromMidnight: number,
            endMinutesFromMidnight: number,
          } >,
        } > | null,
      } >,
    } | null,
  } | null,
};

export type SetIsRunningServiceStatusMutationVariables = {
  input: SetServiceStatusInput,
};

export type SetIsRunningServiceStatusMutation = {
  setIsRunningServiceStatus:  {
    __typename: "Service",
    nodeId?: string | null,
    customerId?: string | null,
    locationId?: string | null,
    deviceId?: string | null,
    serviceType?: string | null,
    configuration?: string | null,
    id?: string | null,
    healthData?: string | null,
    isRunning?: boolean | null,
    modelAlertSettingsId?: string | null,
    modelAlertSettings?:  {
      __typename: "ModelAlertSettings",
      id: string,
      serviceId: string,
      customerId: string,
      deviceId: string,
      timeZone: string,
      modelAlertParameters:  Array< {
        __typename: "ModelAlertParameters",
        objectType: ObjectTypeEnum,
        enabled: boolean,
        activeDays?: Array< DayOfWeekEnum > | null,
        schedules?:  Array< {
          __typename: "AlertSchedule",
          dayOfWeek: DayOfWeekEnum,
          dailyTimeRange:  Array< {
            __typename: "DailyTimeRange",
            startMinutesFromMidnight: number,
            endMinutesFromMidnight: number,
          } >,
        } > | null,
      } >,
    } | null,
  },
};

export type AddAlertSubscriptionMutationVariables = {
  input: AddAlertSubscriptionInput,
};

export type AddAlertSubscriptionMutation = {
  addAlertSubscription?:  {
    __typename: "AlertSubscription",
    entity?: string | null,
    email: string,
  } | null,
};

export type AddAlertWildCardSubscriptionMutationVariables = {
  input: AddAlertWildCardSubscriptionInput,
};

export type AddAlertWildCardSubscriptionMutation = {
  addAlertWildCardSubscription?:  {
    __typename: "AlertWildCardSubscription",
    wildCard: string,
    entity: string,
    email: string,
  } | null,
};

export type AddZoneMutationVariables = {
  input: AddZoneInput,
};

export type AddZoneMutation = {
  addZone:  {
    __typename: "Zone",
    id: string,
    name: string,
    pan: string,
    tilt: string,
    deviceId: string,
    status: boolean,
    serviceId?: string | null,
    inspectTime?: string | null,
    keyFrame?: string | null,
    threshold?:  {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } | null,
    exclusions?: string | null,
    nodeId: string,
    alertData?: string | null,
    zoom?: string | null,
    shouldNotify?: boolean | null,
    signedUrlKeyFrame?: string | null,
  },
};

export type AddZoneThresholdMutationVariables = {
  input: AddZoneThresholdInput,
};

export type AddZoneThresholdMutation = {
  addZoneThreshold:  {
    __typename: "ZoneThreshold",
    id: string,
    name: string,
    value: number,
  },
};

export type AddAnnotationMutationVariables = {
  input: AnnotationInput,
};

export type AddAnnotationMutation = {
  addAnnotation:  {
    __typename: "Annotation",
    id: string,
    serviceId: string,
    deviceId?: string | null,
    zoneId?: string | null,
    polygon?: string | null,
    annotationType: AnnotationType,
    equipmentType?: string | null,
    annotateTanks?: boolean | null,
    name: string,
    tankNumber?: number | null,
    tankHeight?: number | null,
    bottomHidden?: number | null,
  },
};

export type UpdateZoneMutationVariables = {
  input: UpdateZoneInput,
};

export type UpdateZoneMutation = {
  updateZone:  {
    __typename: "Zone",
    id: string,
    name: string,
    pan: string,
    tilt: string,
    deviceId: string,
    status: boolean,
    serviceId?: string | null,
    inspectTime?: string | null,
    keyFrame?: string | null,
    threshold?:  {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } | null,
    exclusions?: string | null,
    nodeId: string,
    alertData?: string | null,
    zoom?: string | null,
    shouldNotify?: boolean | null,
    signedUrlKeyFrame?: string | null,
  },
};

export type UpdateModelAlertSettingsMutationVariables = {
  input: UpdateModelAlertSettingsInput,
};

export type UpdateModelAlertSettingsMutation = {
  updateModelAlertSettings:  {
    __typename: "ModelAlertSettings",
    id: string,
    serviceId: string,
    customerId: string,
    deviceId: string,
    timeZone: string,
    modelAlertParameters:  Array< {
      __typename: "ModelAlertParameters",
      objectType: ObjectTypeEnum,
      enabled: boolean,
      activeDays?: Array< DayOfWeekEnum > | null,
      schedules?:  Array< {
        __typename: "AlertSchedule",
        dayOfWeek: DayOfWeekEnum,
        dailyTimeRange:  Array< {
          __typename: "DailyTimeRange",
          startMinutesFromMidnight: number,
          endMinutesFromMidnight: number,
        } >,
      } > | null,
    } >,
  },
};

export type UpdateZoneThresholdValueMutationVariables = {
  input: UpdateZoneThresholdValueInput,
};

export type UpdateZoneThresholdValueMutation = {
  updateZoneThresholdValue:  {
    __typename: "Zone",
    id: string,
    name: string,
    pan: string,
    tilt: string,
    deviceId: string,
    status: boolean,
    serviceId?: string | null,
    inspectTime?: string | null,
    keyFrame?: string | null,
    threshold?:  {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } | null,
    exclusions?: string | null,
    nodeId: string,
    alertData?: string | null,
    zoom?: string | null,
    shouldNotify?: boolean | null,
    signedUrlKeyFrame?: string | null,
  },
};

export type UpdateZoneThresholdItemMutationVariables = {
  input: UpdateZoneThresholdItemInput,
};

export type UpdateZoneThresholdItemMutation = {
  updateZoneThresholdItem:  {
    __typename: "ZoneThreshold",
    id: string,
    name: string,
    value: number,
  },
};

export type UpdateAnnotationMutationVariables = {
  input: AnnotationInput,
};

export type UpdateAnnotationMutation = {
  updateAnnotation:  {
    __typename: "Annotation",
    id: string,
    serviceId: string,
    deviceId?: string | null,
    zoneId?: string | null,
    polygon?: string | null,
    annotationType: AnnotationType,
    equipmentType?: string | null,
    annotateTanks?: boolean | null,
    name: string,
    tankNumber?: number | null,
    tankHeight?: number | null,
    bottomHidden?: number | null,
  },
};

export type AddAlertEmailNotificationMutationVariables = {
  input?: addAlertEmailNotificationInput | null,
};

export type AddAlertEmailNotificationMutation = {
  addAlertEmailNotification?:  {
    __typename: "Alert",
    id?: string | null,
    alertName?: string | null,
    alertType?: string | null,
    locationTag?: Array< string | null > | null,
    location?: string | null,
    model?: ModelType | null,
    email?: string | null,
    tag?: string | null,
    node?: string | null,
    customService?: string | null,
    jsonObject?: string | null,
    subscribedLevelEntity?: string | null,
    phoneNumber?: string | null,
    notificationSettingsJson?: string | null,
    createdBy: string,
  } | null,
};

export type UpdateAlertMutationVariables = {
  input: UpdateAlertInput,
};

export type UpdateAlertMutation = {
  updateAlert?:  {
    __typename: "Alert",
    id?: string | null,
    alertName?: string | null,
    alertType?: string | null,
    locationTag?: Array< string | null > | null,
    location?: string | null,
    model?: ModelType | null,
    email?: string | null,
    tag?: string | null,
    node?: string | null,
    customService?: string | null,
    jsonObject?: string | null,
    subscribedLevelEntity?: string | null,
    phoneNumber?: string | null,
    notificationSettingsJson?: string | null,
    createdBy: string,
  } | null,
};

export type UpdateAlertStatusMutationVariables = {
  input: UpdateAlertStatusInput,
};

export type UpdateAlertStatusMutation = {
  updateAlertStatus?:  {
    __typename: "Alert",
    id?: string | null,
    alertName?: string | null,
    alertType?: string | null,
    locationTag?: Array< string | null > | null,
    location?: string | null,
    model?: ModelType | null,
    email?: string | null,
    tag?: string | null,
    node?: string | null,
    customService?: string | null,
    jsonObject?: string | null,
    subscribedLevelEntity?: string | null,
    phoneNumber?: string | null,
    notificationSettingsJson?: string | null,
    createdBy: string,
  } | null,
};

export type UpdateAdminEmailAlertMutationVariables = {
  input: UpdateAdminEmailAlertInput,
};

export type UpdateAdminEmailAlertMutation = {
  updateAdminEmailAlert?:  {
    __typename: "Alert",
    id?: string | null,
    alertName?: string | null,
    alertType?: string | null,
    locationTag?: Array< string | null > | null,
    location?: string | null,
    model?: ModelType | null,
    email?: string | null,
    tag?: string | null,
    node?: string | null,
    customService?: string | null,
    jsonObject?: string | null,
    subscribedLevelEntity?: string | null,
    phoneNumber?: string | null,
    notificationSettingsJson?: string | null,
    createdBy: string,
  } | null,
};

export type UpdateAdminSystemAlertMutationVariables = {
  input: UpdateAdminSystemAlertInput,
};

export type UpdateAdminSystemAlertMutation = {
  updateAdminSystemAlert?:  {
    __typename: "Alert",
    id?: string | null,
    alertName?: string | null,
    alertType?: string | null,
    locationTag?: Array< string | null > | null,
    location?: string | null,
    model?: ModelType | null,
    email?: string | null,
    tag?: string | null,
    node?: string | null,
    customService?: string | null,
    jsonObject?: string | null,
    subscribedLevelEntity?: string | null,
    phoneNumber?: string | null,
    notificationSettingsJson?: string | null,
    createdBy: string,
  } | null,
};

export type UpdateUserAlertMutationVariables = {
  input: UpdateUserAlertInput,
};

export type UpdateUserAlertMutation = {
  updateUserAlert?:  {
    __typename: "Alert",
    id?: string | null,
    alertName?: string | null,
    alertType?: string | null,
    locationTag?: Array< string | null > | null,
    location?: string | null,
    model?: ModelType | null,
    email?: string | null,
    tag?: string | null,
    node?: string | null,
    customService?: string | null,
    jsonObject?: string | null,
    subscribedLevelEntity?: string | null,
    phoneNumber?: string | null,
    notificationSettingsJson?: string | null,
    createdBy: string,
  } | null,
};

export type DeleteAlertMutationVariables = {
  input: DeleteAlertInput,
};

export type DeleteAlertMutation = {
  deleteAlert?:  {
    __typename: "Alert",
    id?: string | null,
    alertName?: string | null,
    alertType?: string | null,
    locationTag?: Array< string | null > | null,
    location?: string | null,
    model?: ModelType | null,
    email?: string | null,
    tag?: string | null,
    node?: string | null,
    customService?: string | null,
    jsonObject?: string | null,
    subscribedLevelEntity?: string | null,
    phoneNumber?: string | null,
    notificationSettingsJson?: string | null,
    createdBy: string,
  } | null,
};

export type DeleteZoneMutationVariables = {
  input: DeleteZoneInput,
};

export type DeleteZoneMutation = {
  deleteZone:  {
    __typename: "Zone",
    id: string,
    name: string,
    pan: string,
    tilt: string,
    deviceId: string,
    status: boolean,
    serviceId?: string | null,
    inspectTime?: string | null,
    keyFrame?: string | null,
    threshold?:  {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } | null,
    exclusions?: string | null,
    nodeId: string,
    alertData?: string | null,
    zoom?: string | null,
    shouldNotify?: boolean | null,
    signedUrlKeyFrame?: string | null,
  },
};

export type DeleteZoneThresholdMutationVariables = {
  id: string,
};

export type DeleteZoneThresholdMutation = {
  deleteZoneThreshold:  {
    __typename: "ZoneThreshold",
    id: string,
    name: string,
    value: number,
  },
};

export type DeleteAnnotationMutationVariables = {
  input: DeleteAnnotationInput,
};

export type DeleteAnnotationMutation = {
  deleteAnnotation:  {
    __typename: "Annotation",
    id: string,
    serviceId: string,
    deviceId?: string | null,
    zoneId?: string | null,
    polygon?: string | null,
    annotationType: AnnotationType,
    equipmentType?: string | null,
    annotateTanks?: boolean | null,
    name: string,
    tankNumber?: number | null,
    tankHeight?: number | null,
    bottomHidden?: number | null,
  },
};

export type DeleteAllAnnotationsMutationVariables = {
  input: DeleteAllAnnotationsInput,
};

export type DeleteAllAnnotationsMutation = {
  deleteAllAnnotations?:  {
    __typename: "RemovedAnnotations",
    id?: string | null,
    zoneId?: string | null,
  } | null,
};

export type AddNodeMutationVariables = {
  input: AddNodeInput,
};

export type AddNodeMutation = {
  addNode:  {
    __typename: "Node",
    customerId?: string | null,
    locationId?: string | null,
    id?: string | null,
    nodeName?: string | null,
    nodeId?: string | null,
    level?: NodeLevel | null,
    referenceId?: string | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    serviceData?: string | null,
    deviceData?: string | null,
    onboardCommand?: string | null,
    tags?:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } | null > | null,
    nodeIP?: string | null,
    isOnline?: boolean | null,
  },
};

export type UpdateNodeMutationVariables = {
  input: UpdateNodeInput,
};

export type UpdateNodeMutation = {
  updateNode:  {
    __typename: "Node",
    customerId?: string | null,
    locationId?: string | null,
    id?: string | null,
    nodeName?: string | null,
    nodeId?: string | null,
    level?: NodeLevel | null,
    referenceId?: string | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    serviceData?: string | null,
    deviceData?: string | null,
    onboardCommand?: string | null,
    tags?:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } | null > | null,
    nodeIP?: string | null,
    isOnline?: boolean | null,
  },
};

export type DeleteNodeMutationVariables = {
  nodeId: string,
};

export type DeleteNodeMutation = {
  deleteNode:  {
    __typename: "Node",
    customerId?: string | null,
    locationId?: string | null,
    id?: string | null,
    nodeName?: string | null,
    nodeId?: string | null,
    level?: NodeLevel | null,
    referenceId?: string | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    serviceData?: string | null,
    deviceData?: string | null,
    onboardCommand?: string | null,
    tags?:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } | null > | null,
    nodeIP?: string | null,
    isOnline?: boolean | null,
  },
};

export type UpdateUserSettingsMutationVariables = {
  customerId: string,
  userId: string,
  userSettings: UserSettingsInput,
};

export type UpdateUserSettingsMutation = {
  updateUserSettings:  {
    __typename: "User",
    id: string,
    externalId: string,
    customer_id: string,
    firstName: string,
    lastName: string,
    email: string,
    user_role: string,
    userSettings?: string | null,
  },
};

export type ChangeNodeStatusMutationVariables = {
  input: ChangeNodeStatusInput,
};

export type ChangeNodeStatusMutation = {
  changeNodeStatus: string,
};

export type UpdateProfileMutationVariables = {
  input?: ProfileInput | null,
};

export type UpdateProfileMutation = {
  updateProfile?:  {
    __typename: "Profile",
    id: string,
    name?: string | null,
    file?: string | null,
  } | null,
};

export type EdgeClientMessengerMutationVariables = {
  message?: EdgeClientMessageInput | null,
};

export type EdgeClientMessengerMutation = {
  edgeClientMessenger:  {
    __typename: "EdgeClientMessageResponse",
    id: string,
    statusCode: number,
    topic: string,
    payload: string,
    payloadType: PayloadType,
    timestamp: string,
  },
};

export type UpdateCustomerMutationVariables = {
  input: UpdateCustomerInput,
};

export type UpdateCustomerMutation = {
  updateCustomer:  {
    __typename: "Customer",
    domains?: Array< string > | null,
    id: string,
    externalId: string,
    availableApps?: Array< string > | null,
    name?: string | null,
    pointOfContact?: string | null,
    totalLeakFinderLimit?: number | null,
    usageLeakFinderCount?: number | null,
    allowLeakFinder?: AllowLeakFinder | null,
    configuration?: string | null,
    auditCustomers?: string | null,
    aggAlertingData?: string | null,
    isQuantificationsDisabled?: boolean | null,
    devicePassword?: string | null,
  },
};

export type AddLocationMutationVariables = {
  input: LocationInput,
};

export type AddLocationMutation = {
  addLocation:  {
    __typename: "Location",
    id: string,
    name: string,
    referenceId?: string | null,
    locationData?: string | null,
    tags?:  Array< {
      __typename: "TagOfAssociation",
      id: string,
      associationId: string,
      tagName: string,
    } > | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    timeZone?: string | null,
  },
};

export type UpdateLocationMutationVariables = {
  input: UpdateLocationInput,
};

export type UpdateLocationMutation = {
  updateLocation:  {
    __typename: "Location",
    id: string,
    name: string,
    referenceId?: string | null,
    locationData?: string | null,
    tags?:  Array< {
      __typename: "TagOfAssociation",
      id: string,
      associationId: string,
      tagName: string,
    } > | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    timeZone?: string | null,
  },
};

export type DeleteLocationMutationVariables = {
  customerId: string,
  locationId: string,
};

export type DeleteLocationMutation = {
  deleteLocation: string,
};

export type PublishNodeMutationVariables = {
  input: publishNodeInput,
};

export type PublishNodeMutation = {
  publishNode?:  {
    __typename: "publishNode",
    nodeId: string,
    message: string,
  } | null,
};

export type SetPendingStateMutationVariables = {
  eventId?: string | null,
  customerId?: string | null,
};

export type SetPendingStateMutation = {
  setPendingState:  {
    __typename: "HumanValidationEvent",
    id: string,
    customerId: string,
    locationId: string,
    nodeId: string,
    serviceId: string,
    data?: string | null,
    validationState?: ValidationState | null,
    validated_by?: string | null,
    explanation?: string | null,
    eventTime: string,
    audited_by?: string | null,
    transitionInfo?: string | null,
    auditorsExplanation?: string | null,
  },
};

export type TakeEventToValidateMutationVariables = {
  eventId?: string | null,
  customerId?: string | null,
};

export type TakeEventToValidateMutation = {
  takeEventToValidate:  {
    __typename: "HumanValidationEvent",
    id: string,
    customerId: string,
    locationId: string,
    nodeId: string,
    serviceId: string,
    data?: string | null,
    validationState?: ValidationState | null,
    validated_by?: string | null,
    explanation?: string | null,
    eventTime: string,
    audited_by?: string | null,
    transitionInfo?: string | null,
    auditorsExplanation?: string | null,
  },
};

export type TakeEventToAuditMutationVariables = {
  eventId?: string | null,
  customerId?: string | null,
};

export type TakeEventToAuditMutation = {
  takeEventToAudit:  {
    __typename: "HumanValidationEvent",
    id: string,
    customerId: string,
    locationId: string,
    nodeId: string,
    serviceId: string,
    data?: string | null,
    validationState?: ValidationState | null,
    validated_by?: string | null,
    explanation?: string | null,
    eventTime: string,
    audited_by?: string | null,
    transitionInfo?: string | null,
    auditorsExplanation?: string | null,
  },
};

export type ValidateEventMutationVariables = {
  input: ValidateEventInput,
};

export type ValidateEventMutation = {
  validateEvent:  {
    __typename: "HumanValidationEvent",
    id: string,
    customerId: string,
    locationId: string,
    nodeId: string,
    serviceId: string,
    data?: string | null,
    validationState?: ValidationState | null,
    validated_by?: string | null,
    explanation?: string | null,
    eventTime: string,
    audited_by?: string | null,
    transitionInfo?: string | null,
    auditorsExplanation?: string | null,
  },
};

export type OverruleHumanValidatedEventsMutationVariables = {
  input: ValidateEventInput,
};

export type OverruleHumanValidatedEventsMutation = {
  overruleHumanValidatedEvents:  {
    __typename: "HumanValidationEvent",
    id: string,
    customerId: string,
    locationId: string,
    nodeId: string,
    serviceId: string,
    data?: string | null,
    validationState?: ValidationState | null,
    validated_by?: string | null,
    explanation?: string | null,
    eventTime: string,
    audited_by?: string | null,
    transitionInfo?: string | null,
    auditorsExplanation?: string | null,
  },
};

export type AddDomainMutationVariables = {
  domain: string,
  customerId: string,
};

export type AddDomainMutation = {
  addDomain?:  {
    __typename: "Domain",
    customerId?: string | null,
  } | null,
};

export type AddDeviceMutationVariables = {
  input: AddDeviceInput,
};

export type AddDeviceMutation = {
  addDevice?:  {
    __typename: "Device",
    customerId: string,
    locationId: string,
    locationName?: string | null,
    id: string,
    name: string,
    status?: string | null,
    nodeId: string,
    nodeName?: string | null,
    makeModelId: string,
    cameraIpAddress?: string | null,
    deviceData:  {
      __typename: "DeviceData",
      hasPanTilt: boolean,
      hasRecordVideo: boolean,
      hasZoom: boolean,
      keyFrame: string,
      panTiltIP: string,
      panTiltType?: string | null,
      protocol: string,
      recentFrame: string,
      rtspHost: string,
      sourceVideo: string,
      signedUrlKeyFrame?: string | null,
      signedUrlRecentFrame?: string | null,
    },
    currentPosition?:  {
      __typename: "CurrentPosition",
      pan: string,
      tilt: string,
      zoom?: string | null,
    } | null,
    healthData:  {
      __typename: "DeviceHealthData",
      lastAlive: string,
      isOnline: boolean,
    },
    skuNumber?: string | null,
    configurationName?: string | null,
    serialNumber?: string | null,
    componentSerialNumber?: string | null,
    onboardedAt?: number | null,
  } | null,
};

export type AddDevicesTemplateMutationVariables = {
  input: AddDevicesTemplateInput,
};

export type AddDevicesTemplateMutation = {
  addDevicesTemplate?:  {
    __typename: "DevicesTemplate",
    id: string,
    name: string,
    numberOfNodes: number,
    templateData: string,
  } | null,
};

export type UpdateDeviceMutationVariables = {
  input: UpdateDeviceInput,
};

export type UpdateDeviceMutation = {
  updateDevice?:  {
    __typename: "Device",
    customerId: string,
    locationId: string,
    locationName?: string | null,
    id: string,
    name: string,
    status?: string | null,
    nodeId: string,
    nodeName?: string | null,
    makeModelId: string,
    cameraIpAddress?: string | null,
    deviceData:  {
      __typename: "DeviceData",
      hasPanTilt: boolean,
      hasRecordVideo: boolean,
      hasZoom: boolean,
      keyFrame: string,
      panTiltIP: string,
      panTiltType?: string | null,
      protocol: string,
      recentFrame: string,
      rtspHost: string,
      sourceVideo: string,
      signedUrlKeyFrame?: string | null,
      signedUrlRecentFrame?: string | null,
    },
    currentPosition?:  {
      __typename: "CurrentPosition",
      pan: string,
      tilt: string,
      zoom?: string | null,
    } | null,
    healthData:  {
      __typename: "DeviceHealthData",
      lastAlive: string,
      isOnline: boolean,
    },
    skuNumber?: string | null,
    configurationName?: string | null,
    serialNumber?: string | null,
    componentSerialNumber?: string | null,
    onboardedAt?: number | null,
  } | null,
};

export type DeleteDeviceMutationVariables = {
  customerId: string,
  deviceId: string,
};

export type DeleteDeviceMutation = {
  deleteDevice: string,
};

export type AddDeviceMakeMutationVariables = {
  input: AddDeviceMakeInput,
};

export type AddDeviceMakeMutation = {
  addDeviceMake?:  {
    __typename: "DeviceMake",
    id: string,
    name: string,
    model: string,
    type: string,
    rtspTemplate: string,
    defaultUserPwd?: string | null,
    hasPanTilt: boolean,
    hasZoom?: boolean | null,
    modelsToRun: Array< string | null >,
    deviceTypeShortName?: string | null,
  } | null,
};

export type UpdateDeviceMakeMutationVariables = {
  input: UpdateDeviceMakeInput,
};

export type UpdateDeviceMakeMutation = {
  updateDeviceMake?:  {
    __typename: "DeviceMake",
    id: string,
    name: string,
    model: string,
    type: string,
    rtspTemplate: string,
    defaultUserPwd?: string | null,
    hasPanTilt: boolean,
    hasZoom?: boolean | null,
    modelsToRun: Array< string | null >,
    deviceTypeShortName?: string | null,
  } | null,
};

export type DeleteDeviceMakeMutationVariables = {
  id: string,
};

export type DeleteDeviceMakeMutation = {
  deleteDeviceMake: string,
};

export type DeleteDeviceTemplateMutationVariables = {
  id: string,
};

export type DeleteDeviceTemplateMutation = {
  deleteDeviceTemplate: string,
};

export type AddSKUMutationVariables = {
  input: AddSKUInput,
};

export type AddSKUMutation = {
  addSKU?:  {
    __typename: "SKU",
    id: string,
    skuNumber: string,
    configurationName: string,
    category?: string | null,
    nodeCount: number,
    skuDataConfigurations: string,
    createdAt?: number | null,
    defaultIp?: string | null,
  } | null,
};

export type DeleteSKUMutationVariables = {
  id: string,
};

export type DeleteSKUMutation = {
  deleteSKU: string,
};

export type SendToListenToNodeMessagesMutationVariables = {
  nodeMessage: string,
};

export type SendToListenToNodeMessagesMutation = {
  sendToListenToNodeMessages?:  {
    __typename: "NodeMessage",
    internalNodeId: string,
    message?: string | null,
  } | null,
};

export type SendToListenToNodeFilesMutationVariables = {
  nodeFile: string,
};

export type SendToListenToNodeFilesMutation = {
  sendToListenToNodeFiles:  {
    __typename: "NodeFile",
    internalNodeId: string,
    downloadURL: string,
    file?: string | null,
  },
};

export type SendToListenToHumanValidationEventsMutationVariables = {
  humanValidationEvent: string,
};

export type SendToListenToHumanValidationEventsMutation = {
  sendToListenToHumanValidationEvents:  {
    __typename: "HumanValidationEvent",
    id: string,
    customerId: string,
    locationId: string,
    nodeId: string,
    serviceId: string,
    data?: string | null,
    validationState?: ValidationState | null,
    validated_by?: string | null,
    explanation?: string | null,
    eventTime: string,
    audited_by?: string | null,
    transitionInfo?: string | null,
    auditorsExplanation?: string | null,
  },
};

export type AssignFirstRoleToUserMutationVariables = {
  customerId: string,
  userId: string,
  roleId: string,
  groupId: string,
  userPoolId?: string | null,
};

export type AssignFirstRoleToUserMutation = {
  assignFirstRoleToUser:  {
    __typename: "User",
    id: string,
    externalId: string,
    customer_id: string,
    firstName: string,
    lastName: string,
    email: string,
    user_role: string,
    userSettings?: string | null,
  },
};

export type DeleteUserMutationVariables = {
  customerId: string,
  userId: string,
  userPoolId: string,
};

export type DeleteUserMutation = {
  deleteUser:  {
    __typename: "User",
    id: string,
    externalId: string,
    customer_id: string,
    firstName: string,
    lastName: string,
    email: string,
    user_role: string,
    userSettings?: string | null,
  },
};

export type UpdateNodeOnlineStatusMutationVariables = {
  nodeId: string,
  isOnline?: boolean | null,
};

export type UpdateNodeOnlineStatusMutation = {
  updateNodeOnlineStatus?:  {
    __typename: "NodeIam",
    customerId?: string | null,
    locationId?: string | null,
    id?: string | null,
    nodeName?: string | null,
    nodeId?: string | null,
    level?: NodeLevel | null,
    referenceId?: string | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    serviceData?: string | null,
    deviceData?: string | null,
    onboardCommand?: string | null,
    tags?:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } | null > | null,
    nodeIP?: string | null,
    isOnline?: boolean | null,
  } | null,
};

export type UpdateDeviceDataMutationVariables = {
  customerId: string,
  deviceId: string,
  deviceData?: string | null,
};

export type UpdateDeviceDataMutation = {
  updateDeviceData?:  {
    __typename: "DeviceIam",
    customerId: string,
    locationId: string,
    locationName?: string | null,
    id: string,
    name: string,
    status?: string | null,
    nodeId: string,
    nodeName?: string | null,
    makeModelId: string,
    cameraIpAddress?: string | null,
    deviceData:  {
      __typename: "DeviceDataIam",
      hasPanTilt: boolean,
      hasRecordVideo: boolean,
      hasZoom: boolean,
      keyFrame: string,
      panTiltIP: string,
      panTiltType?: string | null,
      protocol: string,
      recentFrame: string,
      rtspHost: string,
      sourceVideo: string,
      signedUrlKeyFrame?: string | null,
      signedUrlRecentFrame?: string | null,
    },
    currentPosition?:  {
      __typename: "CurrentPosition",
      pan: string,
      tilt: string,
      zoom?: string | null,
    } | null,
    healthData:  {
      __typename: "DeviceHealthDataIam",
      isOnline: boolean,
      lastAlive: string,
    },
  } | null,
};

export type UpdateServiceHealthMutationVariables = {
  input: UpdateServiceHealthInput,
};

export type UpdateServiceHealthMutation = {
  updateServiceHealth?:  {
    __typename: "ServiceIam",
    nodeId?: string | null,
    customerId?: string | null,
    locationId?: string | null,
    deviceId?: string | null,
    serviceType?: string | null,
    configuration?: string | null,
    id?: string | null,
    healthData?: string | null,
    isRunning?: boolean | null,
  } | null,
};

export type SetExpectedOnlineMutationVariables = {
  input: SetExpectedOnlineInput,
};

export type SetExpectedOnlineMutation = {
  setExpectedOnline:  {
    __typename: "SetExpectedOnlineResult",
    updatedCount: number,
  },
};

export type UpdateHealthLeafMetadataMutationVariables = {
  input: UpdateHealthLeafMetadataInput,
};

export type UpdateHealthLeafMetadataMutation = {
  updateHealthLeafMetadata:  {
    __typename: "UpdateHealthLeafMetadataResult",
    updatedCount: number,
  },
};

export type DeleteHealthLeafMutationVariables = {
  input: DeleteHealthLeafInput,
};

export type DeleteHealthLeafMutation = {
  deleteHealthLeaf:  {
    __typename: "DeleteHealthLeafResult",
    deleted: boolean,
    pk1: string,
    sk: string,
  },
};

export type ListHealthLeavesQueryVariables = {
  customerId: string,
  location?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHealthLeavesQuery = {
  listHealthLeaves:  {
    __typename: "PaginatedHealthLeaves",
    items:  Array< {
      __typename: "HealthLeaf",
      pk: string,
      sk: string,
      entity: string,
      customerId: string,
      locationId?: string | null,
      locationName?: string | null,
      nodeId?: string | null,
      nodeName?: string | null,
      deviceId?: string | null,
      deviceName?: string | null,
      serviceType?: string | null,
      isOnline: boolean,
      lastSeenEpochMs?: number | null,
      isExpectedOnline?: boolean | null,
      author?: string | null,
      reason?: string | null,
      toggleTimestamp?: string | null,
      assignedWatcher?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetTimelapseVideoQueryVariables = {
  input: GetTimelapseVideoInput,
};

export type GetTimelapseVideoQuery = {
  getTimelapseVideo?: string | null,
};

export type GetHlsUrlQueryVariables = {
  streamName: string,
};

export type GetHlsUrlQuery = {
  getHlsUrl?: string | null,
};

export type GetSignedUrlActionQueryVariables = {
  input: GetSignedUrlActionInput,
};

export type GetSignedUrlActionQuery = {
  getSignedUrlAction?: string | null,
};

export type GetGroupsByClientQueryVariables = {
  input: GetGroupsByClientInput,
};

export type GetGroupsByClientQuery = {
  getGroupsByClient:  {
    __typename: "PaginatedGroups",
    items:  Array< {
      __typename: "Group",
      id: string,
      customerId: string,
      clientId: string,
      groupName: string,
      createdAt: number,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetGroupByClientIdQueryVariables = {
  input: GetGroupByClientIdInput,
};

export type GetGroupByClientIdQuery = {
  getGroupByClientId?:  {
    __typename: "Group",
    id: string,
    customerId: string,
    clientId: string,
    groupName: string,
    createdAt: number,
  } | null,
};

export type GetClientsByCustomerQueryVariables = {
  input: GetClientsByCustomerInput,
};

export type GetClientsByCustomerQuery = {
  getClientsByCustomer:  {
    __typename: "PaginatedClients",
    items:  Array< {
      __typename: "Client",
      id: string,
      clientName: string,
      customerId: string,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetAllVideosByGroupQueryVariables = {
  input: GetAllVideosByGroupInput,
};

export type GetAllVideosByGroupQuery = {
  getAllVideosByGroup:  {
    __typename: "PaginatedLeakFinderVideos",
    items:  Array< {
      __typename: "LeakFinderVideo",
      id: string,
      customerId: string,
      clientId: string,
      groupId: string,
      videoName: string,
      videoMethod: VideoMethod,
      windspeed: number,
      geometry: string,
      fov?: number | null,
      isVideoProcessed?: boolean | null,
      annotations?: string | null,
      sourceS3Key: string,
      modelOutputS3Key?: string | null,
      notes?: string | null,
      outputMeasurement?: number | null,
      videoState: VideoState,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetAllVideosByStateQueryVariables = {
  input: GetAllVideosByStateInput,
};

export type GetAllVideosByStateQuery = {
  getAllVideosByState:  {
    __typename: "PaginatedLeakFinderVideos",
    items:  Array< {
      __typename: "LeakFinderVideo",
      id: string,
      customerId: string,
      clientId: string,
      groupId: string,
      videoName: string,
      videoMethod: VideoMethod,
      windspeed: number,
      geometry: string,
      fov?: number | null,
      isVideoProcessed?: boolean | null,
      annotations?: string | null,
      sourceS3Key: string,
      modelOutputS3Key?: string | null,
      notes?: string | null,
      outputMeasurement?: number | null,
      videoState: VideoState,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetAllVideosByClientQueryVariables = {
  input?: GetAllVideosByClientInput | null,
};

export type GetAllVideosByClientQuery = {
  getAllVideosByClient:  {
    __typename: "PaginatedLeakFinderVideos",
    items:  Array< {
      __typename: "LeakFinderVideo",
      id: string,
      customerId: string,
      clientId: string,
      groupId: string,
      videoName: string,
      videoMethod: VideoMethod,
      windspeed: number,
      geometry: string,
      fov?: number | null,
      isVideoProcessed?: boolean | null,
      annotations?: string | null,
      sourceS3Key: string,
      modelOutputS3Key?: string | null,
      notes?: string | null,
      outputMeasurement?: number | null,
      videoState: VideoState,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetLicensePlatesByCustomerQueryVariables = {
  input: GetLicensePlatesByCustomerInput,
};

export type GetLicensePlatesByCustomerQuery = {
  getLicensePlatesByCustomer:  {
    __typename: "PaginatedLicensePlates",
    items:  Array< {
      __typename: "LicensePlate",
      id: string,
      categoryId: string,
      company?: string | null,
      driverName?: string | null,
      licensePlate: string,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetLicensePlateQueryVariables = {
  categoryId: string,
  licensePlateId: string,
};

export type GetLicensePlateQuery = {
  getLicensePlate:  {
    __typename: "LicensePlate",
    id: string,
    categoryId: string,
    company?: string | null,
    driverName?: string | null,
    licensePlate: string,
  },
};

export type GetCategoriesByCustomerQueryVariables = {
  input: GetCategoriesByCustomerInput,
};

export type GetCategoriesByCustomerQuery = {
  getCategoriesByCustomer:  {
    __typename: "PaginatedCategories",
    items:  Array< {
      __typename: "Category",
      id: string,
      categoryName: string,
      isAlertEnabled: boolean,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetTagsByCustomerQueryVariables = {
  input: GetTagsByCustomerInput,
};

export type GetTagsByCustomerQuery = {
  getTagsByCustomer:  {
    __typename: "PaginatedTags",
    items:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetTagAssociationsQueryVariables = {
  input: GetTagAssociationsInput,
};

export type GetTagAssociationsQuery = {
  getTagAssociations:  {
    __typename: "PaginatedTagAssociations",
    items:  Array< {
      __typename: "TagOfAssociation",
      id: string,
      associationId: string,
      tagName: string,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetCategoryByIdQueryVariables = {
  input: GetCategoryInput,
};

export type GetCategoryByIdQuery = {
  getCategoryById?:  {
    __typename: "Category",
    id: string,
    categoryName: string,
    isAlertEnabled: boolean,
  } | null,
};

export type GetClientByIdQueryVariables = {
  input: GetClientInput,
};

export type GetClientByIdQuery = {
  getClientById?:  {
    __typename: "Client",
    id: string,
    clientName: string,
    customerId: string,
  } | null,
};

export type GetNodeByIdQueryVariables = {
  nodeId: string,
};

export type GetNodeByIdQuery = {
  getNodeById?:  {
    __typename: "Node",
    customerId?: string | null,
    locationId?: string | null,
    id?: string | null,
    nodeName?: string | null,
    nodeId?: string | null,
    level?: NodeLevel | null,
    referenceId?: string | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    serviceData?: string | null,
    deviceData?: string | null,
    onboardCommand?: string | null,
    tags?:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } | null > | null,
    nodeIP?: string | null,
    isOnline?: boolean | null,
  } | null,
};

export type GetServiceByIdQueryVariables = {
  input: GetServiceInput,
};

export type GetServiceByIdQuery = {
  getServiceById:  {
    __typename: "Service",
    nodeId?: string | null,
    customerId?: string | null,
    locationId?: string | null,
    deviceId?: string | null,
    serviceType?: string | null,
    configuration?: string | null,
    id?: string | null,
    healthData?: string | null,
    isRunning?: boolean | null,
    modelAlertSettingsId?: string | null,
    modelAlertSettings?:  {
      __typename: "ModelAlertSettings",
      id: string,
      serviceId: string,
      customerId: string,
      deviceId: string,
      timeZone: string,
      modelAlertParameters:  Array< {
        __typename: "ModelAlertParameters",
        objectType: ObjectTypeEnum,
        enabled: boolean,
        activeDays?: Array< DayOfWeekEnum > | null,
        schedules?:  Array< {
          __typename: "AlertSchedule",
          dayOfWeek: DayOfWeekEnum,
          dailyTimeRange:  Array< {
            __typename: "DailyTimeRange",
            startMinutesFromMidnight: number,
            endMinutesFromMidnight: number,
          } >,
        } > | null,
      } >,
    } | null,
  },
};

export type GetModelAlertSettingsQueryVariables = {
  input: GetModelAlertSettingsInput,
};

export type GetModelAlertSettingsQuery = {
  getModelAlertSettings:  {
    __typename: "PaginatedModelAlertSettings",
    items:  Array< {
      __typename: "ModelAlertSettings",
      id: string,
      serviceId: string,
      customerId: string,
      deviceId: string,
      timeZone: string,
      modelAlertParameters:  Array< {
        __typename: "ModelAlertParameters",
        objectType: ObjectTypeEnum,
        enabled: boolean,
        activeDays?: Array< DayOfWeekEnum > | null,
        schedules?:  Array< {
          __typename: "AlertSchedule",
          dayOfWeek: DayOfWeekEnum,
          dailyTimeRange:  Array< {
            __typename: "DailyTimeRange",
            startMinutesFromMidnight: number,
            endMinutesFromMidnight: number,
          } >,
        } > | null,
      } >,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetServicesQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
  modelAlertSettingsSelectionKey?: SelectionKey | null,
  customerId?: string | null,
  locationId?: string | null,
};

export type GetServicesQuery = {
  getServices:  {
    __typename: "PaginatedServices",
    items:  Array< {
      __typename: "Service",
      nodeId?: string | null,
      customerId?: string | null,
      locationId?: string | null,
      deviceId?: string | null,
      serviceType?: string | null,
      configuration?: string | null,
      id?: string | null,
      healthData?: string | null,
      isRunning?: boolean | null,
      modelAlertSettingsId?: string | null,
      modelAlertSettings?:  {
        __typename: "ModelAlertSettings",
        id: string,
        serviceId: string,
        customerId: string,
        deviceId: string,
        timeZone: string,
        modelAlertParameters:  Array< {
          __typename: "ModelAlertParameters",
          objectType: ObjectTypeEnum,
          enabled: boolean,
          activeDays?: Array< DayOfWeekEnum > | null,
          schedules?:  Array< {
            __typename: "AlertSchedule",
            dayOfWeek: DayOfWeekEnum,
            dailyTimeRange:  Array< {
              __typename: "DailyTimeRange",
              startMinutesFromMidnight: number,
              endMinutesFromMidnight: number,
            } >,
          } > | null,
        } >,
      } | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetServicesByDeviceQueryVariables = {
  deviceId: string,
  nextToken?: string | null,
};

export type GetServicesByDeviceQuery = {
  getServicesByDevice:  {
    __typename: "PaginatedServices",
    items:  Array< {
      __typename: "Service",
      nodeId?: string | null,
      customerId?: string | null,
      locationId?: string | null,
      deviceId?: string | null,
      serviceType?: string | null,
      configuration?: string | null,
      id?: string | null,
      healthData?: string | null,
      isRunning?: boolean | null,
      modelAlertSettingsId?: string | null,
      modelAlertSettings?:  {
        __typename: "ModelAlertSettings",
        id: string,
        serviceId: string,
        customerId: string,
        deviceId: string,
        timeZone: string,
        modelAlertParameters:  Array< {
          __typename: "ModelAlertParameters",
          objectType: ObjectTypeEnum,
          enabled: boolean,
          activeDays?: Array< DayOfWeekEnum > | null,
          schedules?:  Array< {
            __typename: "AlertSchedule",
            dayOfWeek: DayOfWeekEnum,
            dailyTimeRange:  Array< {
              __typename: "DailyTimeRange",
              startMinutesFromMidnight: number,
              endMinutesFromMidnight: number,
            } >,
          } > | null,
        } >,
      } | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetServicesByNodeQueryVariables = {
  nodeId: string,
  modelAlertSettingsSelectionKey?: SelectionKey | null,
  nextToken?: string | null,
};

export type GetServicesByNodeQuery = {
  getServicesByNode:  {
    __typename: "PaginatedServices",
    items:  Array< {
      __typename: "Service",
      nodeId?: string | null,
      customerId?: string | null,
      locationId?: string | null,
      deviceId?: string | null,
      serviceType?: string | null,
      configuration?: string | null,
      id?: string | null,
      healthData?: string | null,
      isRunning?: boolean | null,
      modelAlertSettingsId?: string | null,
      modelAlertSettings?:  {
        __typename: "ModelAlertSettings",
        id: string,
        serviceId: string,
        customerId: string,
        deviceId: string,
        timeZone: string,
        modelAlertParameters:  Array< {
          __typename: "ModelAlertParameters",
          objectType: ObjectTypeEnum,
          enabled: boolean,
          activeDays?: Array< DayOfWeekEnum > | null,
          schedules?:  Array< {
            __typename: "AlertSchedule",
            dayOfWeek: DayOfWeekEnum,
            dailyTimeRange:  Array< {
              __typename: "DailyTimeRange",
              startMinutesFromMidnight: number,
              endMinutesFromMidnight: number,
            } >,
          } > | null,
        } >,
      } | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetDTObjectQueryVariables = {
  objectId: string,
};

export type GetDTObjectQuery = {
  getDTObject?:  {
    __typename: "DTObject",
    id: string,
    version?: number | null,
    objectId: string,
    objectName: string,
    objectType: string,
    objectManufacturerName: string,
    isCustomerObject: boolean,
    filesInfo:  Array< {
      __typename: "DTObjectFileInfo",
      id: string,
      originalFileName: string,
      contentType: string,
      useType: string,
      key: string,
    } >,
  } | null,
};

export type GetDTObjectsQuery = {
  getDTObjects?:  Array< {
    __typename: "DTObject",
    id: string,
    version?: number | null,
    objectId: string,
    objectName: string,
    objectType: string,
    objectManufacturerName: string,
    isCustomerObject: boolean,
    filesInfo:  Array< {
      __typename: "DTObjectFileInfo",
      id: string,
      originalFileName: string,
      contentType: string,
      useType: string,
      key: string,
    } >,
  } | null > | null,
};

export type GetCustomerDTObjectQueryVariables = {
  customerId?: string | null,
  objectId: string,
};

export type GetCustomerDTObjectQuery = {
  getCustomerDTObject?:  {
    __typename: "DTObject",
    id: string,
    version?: number | null,
    objectId: string,
    objectName: string,
    objectType: string,
    objectManufacturerName: string,
    isCustomerObject: boolean,
    filesInfo:  Array< {
      __typename: "DTObjectFileInfo",
      id: string,
      originalFileName: string,
      contentType: string,
      useType: string,
      key: string,
    } >,
  } | null,
};

export type GetCustomerDTObjectsQueryVariables = {
  customerId?: string | null,
};

export type GetCustomerDTObjectsQuery = {
  getCustomerDTObjects?:  Array< {
    __typename: "DTObject",
    id: string,
    version?: number | null,
    objectId: string,
    objectName: string,
    objectType: string,
    objectManufacturerName: string,
    isCustomerObject: boolean,
    filesInfo:  Array< {
      __typename: "DTObjectFileInfo",
      id: string,
      originalFileName: string,
      contentType: string,
      useType: string,
      key: string,
    } >,
  } | null > | null,
};

export type GetDTFileQueryVariables = {
  key?: string | null,
};

export type GetDTFileQuery = {
  getDTFile?:  {
    __typename: "DTFile",
    key?: string | null,
    url?: string | null,
  } | null,
};

export type GetDTFilesQueryVariables = {
  keys?: Array< string | null > | null,
};

export type GetDTFilesQuery = {
  getDTFiles?:  Array< {
    __typename: "DTFile",
    key?: string | null,
    url?: string | null,
  } | null > | null,
};

export type GetDTProjectQueryVariables = {
  customerId: string,
  projectId: string,
};

export type GetDTProjectQuery = {
  getDTProject?:  {
    __typename: "DTProject",
    id?: string | null,
    projectId?: string | null,
    customerId?: string | null,
    displayName?: string | null,
    lastModifierUserName?: string | null,
    lastModificationDate?: string | null,
    configURL?: string | null,
    withKMZLayer?: boolean | null,
    kmzLayerURL?: string | null,
    measurementSystem?: string | null,
  } | null,
};

export type GetDTProjectsQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetDTProjectsQuery = {
  getDTProjects?:  {
    __typename: "PaginatedDTProjects",
    items:  Array< {
      __typename: "DTProject",
      id?: string | null,
      projectId?: string | null,
      customerId?: string | null,
      displayName?: string | null,
      lastModifierUserName?: string | null,
      lastModificationDate?: string | null,
      configURL?: string | null,
      withKMZLayer?: boolean | null,
      kmzLayerURL?: string | null,
      measurementSystem?: string | null,
    } | null >,
    nextToken?: string | null,
    limit?: number | null,
  } | null,
};

export type GetDTCustomerProjectsQueryVariables = {
  customerId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetDTCustomerProjectsQuery = {
  getDTCustomerProjects?:  {
    __typename: "PaginatedDTProjects",
    items:  Array< {
      __typename: "DTProject",
      id?: string | null,
      projectId?: string | null,
      customerId?: string | null,
      displayName?: string | null,
      lastModifierUserName?: string | null,
      lastModificationDate?: string | null,
      configURL?: string | null,
      withKMZLayer?: boolean | null,
      kmzLayerURL?: string | null,
      measurementSystem?: string | null,
    } | null >,
    nextToken?: string | null,
    limit?: number | null,
  } | null,
};

export type GetDTProjectsByUsedDTObjectQueryVariables = {
  customerId: string,
  objectId: string,
};

export type GetDTProjectsByUsedDTObjectQuery = {
  getDTProjectsByUsedDTObject?:  Array< {
    __typename: "DTProject",
    id?: string | null,
    projectId?: string | null,
    customerId?: string | null,
    displayName?: string | null,
    lastModifierUserName?: string | null,
    lastModificationDate?: string | null,
    configURL?: string | null,
    withKMZLayer?: boolean | null,
    kmzLayerURL?: string | null,
    measurementSystem?: string | null,
  } | null > | null,
};

export type GetShadowNodeQueryVariables = {
  thingName?: string | null,
  shadowName?: string | null,
};

export type GetShadowNodeQuery = {
  getShadowNode?:  {
    __typename: "Shadow",
    shadow?: string | null,
  } | null,
};

export type GetTimestreamDataQueryVariables = {
  input?: TimestreamDataInput | null,
};

export type GetTimestreamDataQuery = {
  getTimestreamData?: string | null,
};

export type GetStatisticsDataQueryVariables = {
  input?: StatisticsDataInput | null,
};

export type GetStatisticsDataQuery = {
  getStatisticsData?: string | null,
};

export type GetS3FilesQueryVariables = {
  input?: S3FilesInput | null,
};

export type GetS3FilesQuery = {
  getS3Files?: string | null,
};

export type GetProfileQuery = {
  getProfile?:  {
    __typename: "Profile",
    id: string,
    name?: string | null,
    file?: string | null,
  } | null,
};

export type GetCustomerQueryVariables = {
  customerId: string,
  customerExternalId: string,
};

export type GetCustomerQuery = {
  getCustomer:  {
    __typename: "Customer",
    domains?: Array< string > | null,
    id: string,
    externalId: string,
    availableApps?: Array< string > | null,
    name?: string | null,
    pointOfContact?: string | null,
    totalLeakFinderLimit?: number | null,
    usageLeakFinderCount?: number | null,
    allowLeakFinder?: AllowLeakFinder | null,
    configuration?: string | null,
    auditCustomers?: string | null,
    aggAlertingData?: string | null,
    isQuantificationsDisabled?: boolean | null,
    devicePassword?: string | null,
  },
};

export type GetCustomerCountersQueryVariables = {
  customerId: string,
  customerExternalId: string,
};

export type GetCustomerCountersQuery = {
  getCustomerCounters:  {
    __typename: "CustomerCountersType",
    id: string,
    totalLeakFinderLimit?: number | null,
    usageLeakFinderCount?: number | null,
    allowLeakFinder?: AllowLeakFinder | null,
  },
};

export type GetCustomersQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetCustomersQuery = {
  getCustomers:  {
    __typename: "PaginatedCustomers",
    items:  Array< {
      __typename: "Customer",
      domains?: Array< string > | null,
      id: string,
      externalId: string,
      availableApps?: Array< string > | null,
      name?: string | null,
      pointOfContact?: string | null,
      totalLeakFinderLimit?: number | null,
      usageLeakFinderCount?: number | null,
      allowLeakFinder?: AllowLeakFinder | null,
      configuration?: string | null,
      auditCustomers?: string | null,
      aggAlertingData?: string | null,
      isQuantificationsDisabled?: boolean | null,
      devicePassword?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetLocationsQueryVariables = {
  customerId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetLocationsQuery = {
  getLocations:  {
    __typename: "PaginatedLocations",
    items:  Array< {
      __typename: "Location",
      id: string,
      name: string,
      referenceId?: string | null,
      locationData?: string | null,
      tags?:  Array< {
        __typename: "TagOfAssociation",
        id: string,
        associationId: string,
        tagName: string,
      } > | null,
      devices?:  Array< {
        __typename: "Device",
        customerId: string,
        locationId: string,
        locationName?: string | null,
        id: string,
        name: string,
        status?: string | null,
        nodeId: string,
        nodeName?: string | null,
        makeModelId: string,
        cameraIpAddress?: string | null,
        deviceData:  {
          __typename: "DeviceData",
          hasPanTilt: boolean,
          hasRecordVideo: boolean,
          hasZoom: boolean,
          keyFrame: string,
          panTiltIP: string,
          panTiltType?: string | null,
          protocol: string,
          recentFrame: string,
          rtspHost: string,
          sourceVideo: string,
          signedUrlKeyFrame?: string | null,
          signedUrlRecentFrame?: string | null,
        },
        currentPosition?:  {
          __typename: "CurrentPosition",
          pan: string,
          tilt: string,
          zoom?: string | null,
        } | null,
        healthData:  {
          __typename: "DeviceHealthData",
          lastAlive: string,
          isOnline: boolean,
        },
        skuNumber?: string | null,
        configurationName?: string | null,
        serialNumber?: string | null,
        componentSerialNumber?: string | null,
        onboardedAt?: number | null,
      } > | null,
      timeZone?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetEventsPendingHumanValidationQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetEventsPendingHumanValidationQuery = {
  getEventsPendingHumanValidation:  {
    __typename: "PaginatedHumanValidationEvents",
    items:  Array< {
      __typename: "HumanValidationEvent",
      id: string,
      customerId: string,
      locationId: string,
      nodeId: string,
      serviceId: string,
      data?: string | null,
      validationState?: ValidationState | null,
      validated_by?: string | null,
      explanation?: string | null,
      eventTime: string,
      audited_by?: string | null,
      transitionInfo?: string | null,
      auditorsExplanation?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetEventsPendingHumanValidationByTenantQueryVariables = {
  tenantId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetEventsPendingHumanValidationByTenantQuery = {
  getEventsPendingHumanValidationByTenant:  {
    __typename: "PaginatedHumanValidationEvents",
    items:  Array< {
      __typename: "HumanValidationEvent",
      id: string,
      customerId: string,
      locationId: string,
      nodeId: string,
      serviceId: string,
      data?: string | null,
      validationState?: ValidationState | null,
      validated_by?: string | null,
      explanation?: string | null,
      eventTime: string,
      audited_by?: string | null,
      transitionInfo?: string | null,
      auditorsExplanation?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetHumanValidatedEventsForAuditingQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetHumanValidatedEventsForAuditingQuery = {
  getHumanValidatedEventsForAuditing:  {
    __typename: "PaginatedHumanValidationEvents",
    items:  Array< {
      __typename: "HumanValidationEvent",
      id: string,
      customerId: string,
      locationId: string,
      nodeId: string,
      serviceId: string,
      data?: string | null,
      validationState?: ValidationState | null,
      validated_by?: string | null,
      explanation?: string | null,
      eventTime: string,
      audited_by?: string | null,
      transitionInfo?: string | null,
      auditorsExplanation?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetLocationsByTagQueryVariables = {
  customerId: string,
  tag: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetLocationsByTagQuery = {
  getLocationsByTag:  {
    __typename: "PaginatedLocations",
    items:  Array< {
      __typename: "Location",
      id: string,
      name: string,
      referenceId?: string | null,
      locationData?: string | null,
      tags?:  Array< {
        __typename: "TagOfAssociation",
        id: string,
        associationId: string,
        tagName: string,
      } > | null,
      devices?:  Array< {
        __typename: "Device",
        customerId: string,
        locationId: string,
        locationName?: string | null,
        id: string,
        name: string,
        status?: string | null,
        nodeId: string,
        nodeName?: string | null,
        makeModelId: string,
        cameraIpAddress?: string | null,
        deviceData:  {
          __typename: "DeviceData",
          hasPanTilt: boolean,
          hasRecordVideo: boolean,
          hasZoom: boolean,
          keyFrame: string,
          panTiltIP: string,
          panTiltType?: string | null,
          protocol: string,
          recentFrame: string,
          rtspHost: string,
          sourceVideo: string,
          signedUrlKeyFrame?: string | null,
          signedUrlRecentFrame?: string | null,
        },
        currentPosition?:  {
          __typename: "CurrentPosition",
          pan: string,
          tilt: string,
          zoom?: string | null,
        } | null,
        healthData:  {
          __typename: "DeviceHealthData",
          lastAlive: string,
          isOnline: boolean,
        },
        skuNumber?: string | null,
        configurationName?: string | null,
        serialNumber?: string | null,
        componentSerialNumber?: string | null,
        onboardedAt?: number | null,
      } > | null,
      timeZone?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetLocationByIdQueryVariables = {
  customerId: string,
  locationId: string,
};

export type GetLocationByIdQuery = {
  getLocationById:  {
    __typename: "Location",
    id: string,
    name: string,
    referenceId?: string | null,
    locationData?: string | null,
    tags?:  Array< {
      __typename: "TagOfAssociation",
      id: string,
      associationId: string,
      tagName: string,
    } > | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    timeZone?: string | null,
  },
};

export type GetFormQueryVariables = {
  customerId: string,
  itemId: string,
};

export type GetFormQuery = {
  getForm:  {
    __typename: "Form",
    id?: string | null,
    customerId?: string | null,
    fields?:  Array< {
      __typename: "Field",
      name: string,
      type: string,
      entries?: Array< string | null > | null,
      itemToQuery?: string | null,
    } | null > | null,
  },
};

export type GetNodesQueryVariables = {
  locationId?: string | null,
  customerId?: string | null,
  tagId?: string | null,
  includeDevices?: boolean | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetNodesQuery = {
  getNodes:  {
    __typename: "PaginatedNodes",
    items:  Array< {
      __typename: "Node",
      customerId?: string | null,
      locationId?: string | null,
      id?: string | null,
      nodeName?: string | null,
      nodeId?: string | null,
      level?: NodeLevel | null,
      referenceId?: string | null,
      devices?:  Array< {
        __typename: "Device",
        customerId: string,
        locationId: string,
        locationName?: string | null,
        id: string,
        name: string,
        status?: string | null,
        nodeId: string,
        nodeName?: string | null,
        makeModelId: string,
        cameraIpAddress?: string | null,
        deviceData:  {
          __typename: "DeviceData",
          hasPanTilt: boolean,
          hasRecordVideo: boolean,
          hasZoom: boolean,
          keyFrame: string,
          panTiltIP: string,
          panTiltType?: string | null,
          protocol: string,
          recentFrame: string,
          rtspHost: string,
          sourceVideo: string,
          signedUrlKeyFrame?: string | null,
          signedUrlRecentFrame?: string | null,
        },
        currentPosition?:  {
          __typename: "CurrentPosition",
          pan: string,
          tilt: string,
          zoom?: string | null,
        } | null,
        healthData:  {
          __typename: "DeviceHealthData",
          lastAlive: string,
          isOnline: boolean,
        },
        skuNumber?: string | null,
        configurationName?: string | null,
        serialNumber?: string | null,
        componentSerialNumber?: string | null,
        onboardedAt?: number | null,
      } > | null,
      serviceData?: string | null,
      deviceData?: string | null,
      onboardCommand?: string | null,
      tags?:  Array< {
        __typename: "Tag",
        id: string,
        tagName: string,
      } | null > | null,
      nodeIP?: string | null,
      isOnline?: boolean | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetDeviceByIdQueryVariables = {
  customerId: string,
  deviceId: string,
};

export type GetDeviceByIdQuery = {
  getDeviceById?:  {
    __typename: "Device",
    customerId: string,
    locationId: string,
    locationName?: string | null,
    id: string,
    name: string,
    status?: string | null,
    nodeId: string,
    nodeName?: string | null,
    makeModelId: string,
    cameraIpAddress?: string | null,
    deviceData:  {
      __typename: "DeviceData",
      hasPanTilt: boolean,
      hasRecordVideo: boolean,
      hasZoom: boolean,
      keyFrame: string,
      panTiltIP: string,
      panTiltType?: string | null,
      protocol: string,
      recentFrame: string,
      rtspHost: string,
      sourceVideo: string,
      signedUrlKeyFrame?: string | null,
      signedUrlRecentFrame?: string | null,
    },
    currentPosition?:  {
      __typename: "CurrentPosition",
      pan: string,
      tilt: string,
      zoom?: string | null,
    } | null,
    healthData:  {
      __typename: "DeviceHealthData",
      lastAlive: string,
      isOnline: boolean,
    },
    skuNumber?: string | null,
    configurationName?: string | null,
    serialNumber?: string | null,
    componentSerialNumber?: string | null,
    onboardedAt?: number | null,
  } | null,
};

export type GetDevicesQueryVariables = {
  customerId: string,
  locationId?: string | null,
  nodeId?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetDevicesQuery = {
  getDevices:  {
    __typename: "PaginatedDevices",
    items:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetDeviceMakeByIdQueryVariables = {
  makeModelId: string,
};

export type GetDeviceMakeByIdQuery = {
  getDeviceMakeById:  {
    __typename: "DeviceMake",
    id: string,
    name: string,
    model: string,
    type: string,
    rtspTemplate: string,
    defaultUserPwd?: string | null,
    hasPanTilt: boolean,
    hasZoom?: boolean | null,
    modelsToRun: Array< string | null >,
    deviceTypeShortName?: string | null,
  },
};

export type GetDeviceMakeByModelQueryVariables = {
  makeModelName: string,
};

export type GetDeviceMakeByModelQuery = {
  getDeviceMakeByModel:  {
    __typename: "DeviceMake",
    id: string,
    name: string,
    model: string,
    type: string,
    rtspTemplate: string,
    defaultUserPwd?: string | null,
    hasPanTilt: boolean,
    hasZoom?: boolean | null,
    modelsToRun: Array< string | null >,
    deviceTypeShortName?: string | null,
  },
};

export type GetDevicesMakesQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetDevicesMakesQuery = {
  getDevicesMakes:  {
    __typename: "PaginatedDevicesMakes",
    items:  Array< {
      __typename: "DeviceMake",
      id: string,
      name: string,
      model: string,
      type: string,
      rtspTemplate: string,
      defaultUserPwd?: string | null,
      hasPanTilt: boolean,
      hasZoom?: boolean | null,
      modelsToRun: Array< string | null >,
      deviceTypeShortName?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetDeviceTemplatesQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetDeviceTemplatesQuery = {
  getDeviceTemplates:  {
    __typename: "PaginatedDeviceTemplates",
    items:  Array< {
      __typename: "DevicesTemplate",
      id: string,
      name: string,
      numberOfNodes: number,
      templateData: string,
    } | null >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetSKUsQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetSKUsQuery = {
  getSKUs:  {
    __typename: "PaginatedSKUs",
    items:  Array< {
      __typename: "SKU",
      id: string,
      skuNumber: string,
      configurationName: string,
      category?: string | null,
      nodeCount: number,
      skuDataConfigurations: string,
      createdAt?: number | null,
      defaultIp?: string | null,
    } | null >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetDevicesByLocationQueryVariables = {
  locationId: string,
  nextToken?: string | null,
};

export type GetDevicesByLocationQuery = {
  getDevicesByLocation?:  {
    __typename: "PaginatedDevices",
    items:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  } | null,
};

export type GetZonesQueryVariables = {
  customerId: string,
  serviceId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetZonesQuery = {
  getZones:  {
    __typename: "PaginatedZones",
    items:  Array< {
      __typename: "Zone",
      id: string,
      name: string,
      pan: string,
      tilt: string,
      deviceId: string,
      status: boolean,
      serviceId?: string | null,
      inspectTime?: string | null,
      keyFrame?: string | null,
      threshold?:  {
        __typename: "ZoneThreshold",
        id: string,
        name: string,
        value: number,
      } | null,
      exclusions?: string | null,
      nodeId: string,
      alertData?: string | null,
      zoom?: string | null,
      shouldNotify?: boolean | null,
      signedUrlKeyFrame?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetZoneQueryVariables = {
  customerId: string,
  deviceId: string,
  zoneId: string,
};

export type GetZoneQuery = {
  getZone:  {
    __typename: "Zone",
    id: string,
    name: string,
    pan: string,
    tilt: string,
    deviceId: string,
    status: boolean,
    serviceId?: string | null,
    inspectTime?: string | null,
    keyFrame?: string | null,
    threshold?:  {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } | null,
    exclusions?: string | null,
    nodeId: string,
    alertData?: string | null,
    zoom?: string | null,
    shouldNotify?: boolean | null,
    signedUrlKeyFrame?: string | null,
  },
};

export type GetZonesThresholdsByCustomerQueryVariables = {
  input: GetZonesThresholdsByCustomerInput,
};

export type GetZonesThresholdsByCustomerQuery = {
  getZonesThresholdsByCustomer:  {
    __typename: "PaginatedZonesThresholds",
    items:  Array< {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetZoneThresholdByIdQueryVariables = {
  input: GetZoneThresholdInput,
};

export type GetZoneThresholdByIdQuery = {
  getZoneThresholdById?:  {
    __typename: "ZoneThreshold",
    id: string,
    name: string,
    value: number,
  } | null,
};

export type GetZonesByDeviceQueryVariables = {
  deviceId: string,
  customerId: string,
  limit?: number | null,
  nextToken?: string | null,
  filterByCustomer?: boolean | null,
};

export type GetZonesByDeviceQuery = {
  getZonesByDevice:  {
    __typename: "PaginatedZones",
    items:  Array< {
      __typename: "Zone",
      id: string,
      name: string,
      pan: string,
      tilt: string,
      deviceId: string,
      status: boolean,
      serviceId?: string | null,
      inspectTime?: string | null,
      keyFrame?: string | null,
      threshold?:  {
        __typename: "ZoneThreshold",
        id: string,
        name: string,
        value: number,
      } | null,
      exclusions?: string | null,
      nodeId: string,
      alertData?: string | null,
      zoom?: string | null,
      shouldNotify?: boolean | null,
      signedUrlKeyFrame?: string | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetAnnotationsQueryVariables = {
  input: GetAnnotationsInput,
};

export type GetAnnotationsQuery = {
  getAnnotations:  {
    __typename: "PaginatedAnnotations",
    items:  Array< {
      __typename: "Annotation",
      id: string,
      serviceId: string,
      deviceId?: string | null,
      zoneId?: string | null,
      polygon?: string | null,
      annotationType: AnnotationType,
      equipmentType?: string | null,
      annotateTanks?: boolean | null,
      name: string,
      tankNumber?: number | null,
      tankHeight?: number | null,
      bottomHidden?: number | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetSubscriptionsForEmailQueryVariables = {
  entity: string,
  email: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetSubscriptionsForEmailQuery = {
  getSubscriptionsForEmail:  {
    __typename: "PaginatedSubscriptionsForEmail",
    items:  Array< {
      __typename: "AlertSubscription",
      entity?: string | null,
      email: string,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetAllEmailsForSubscriptionEntityQueryVariables = {
  entity: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllEmailsForSubscriptionEntityQuery = {
  getAllEmailsForSubscriptionEntity:  {
    __typename: "PaginatedAllEmailsForSubscriptionEntity",
    items:  Array< {
      __typename: "AlertSubscription",
      entity?: string | null,
      email: string,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetAllSubscriptionsQueryVariables = {
  entity: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllSubscriptionsQuery = {
  getAllSubscriptions:  {
    __typename: "PaginatedAlertSubscriptions",
    items:  Array< {
      __typename: "AlertSubscription",
      entity?: string | null,
      email: string,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetAllWildCardsForSubscriptionEntityQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllWildCardsForSubscriptionEntityQuery = {
  getAllWildCardsForSubscriptionEntity:  {
    __typename: "PaginatedWildCardsForSubscriptionEntity",
    items:  Array< {
      __typename: "AlertWildCardSubscription",
      wildCard: string,
      entity: string,
      email: string,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetDevicesByNodeIdQueryVariables = {
  nodeId: string,
  nextToken?: string | null,
};

export type GetDevicesByNodeIdQuery = {
  getDevicesByNodeId?:  {
    __typename: "PaginatedDevices",
    items:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  } | null,
};

export type QueryingDevicesByTagQueryVariables = {
  tagId: string,
};

export type QueryingDevicesByTagQuery = {
  queryingDevicesByTag:  {
    __typename: "PaginatedDevices",
    items:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetUserByIdQuery = {
  getUserById:  {
    __typename: "User",
    id: string,
    externalId: string,
    customer_id: string,
    firstName: string,
    lastName: string,
    email: string,
    user_role: string,
    userSettings?: string | null,
  },
};

export type GetAllAlertsQueryVariables = {
  customerId: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAllAlertsQuery = {
  getAllAlerts:  {
    __typename: "PaginatedAlerts",
    items:  Array< {
      __typename: "Alert",
      id?: string | null,
      alertName?: string | null,
      alertType?: string | null,
      locationTag?: Array< string | null > | null,
      location?: string | null,
      model?: ModelType | null,
      email?: string | null,
      tag?: string | null,
      node?: string | null,
      customService?: string | null,
      jsonObject?: string | null,
      subscribedLevelEntity?: string | null,
      phoneNumber?: string | null,
      notificationSettingsJson?: string | null,
      createdBy: string,
    } | null >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type GetUserAlertsQueryVariables = {
  customerId: string,
  email: string,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUserAlertsQuery = {
  getUserAlerts:  {
    __typename: "PaginatedAlerts",
    items:  Array< {
      __typename: "Alert",
      id?: string | null,
      alertName?: string | null,
      alertType?: string | null,
      locationTag?: Array< string | null > | null,
      location?: string | null,
      model?: ModelType | null,
      email?: string | null,
      tag?: string | null,
      node?: string | null,
      customService?: string | null,
      jsonObject?: string | null,
      subscribedLevelEntity?: string | null,
      phoneNumber?: string | null,
      notificationSettingsJson?: string | null,
      createdBy: string,
    } | null >,
    nextToken?: string | null,
    limit?: number | null,
  },
};

export type ListenToNodeMessagesSubscriptionVariables = {
  nodeId: string,
};

export type ListenToNodeMessagesSubscription = {
  listenToNodeMessages?:  {
    __typename: "NodeMessage",
    internalNodeId: string,
    message?: string | null,
  } | null,
};

export type ListenToNodeFilesSubscriptionVariables = {
  nodeId: string,
};

export type ListenToNodeFilesSubscription = {
  listenToNodeFiles?:  {
    __typename: "NodeFile",
    internalNodeId: string,
    downloadURL: string,
    file?: string | null,
  } | null,
};

export type ListenToDeviceDataSubscriptionVariables = {
  customerId: string,
};

export type ListenToDeviceDataSubscription = {
  listenToDeviceData?:  {
    __typename: "DeviceIam",
    customerId: string,
    locationId: string,
    locationName?: string | null,
    id: string,
    name: string,
    status?: string | null,
    nodeId: string,
    nodeName?: string | null,
    makeModelId: string,
    cameraIpAddress?: string | null,
    deviceData:  {
      __typename: "DeviceDataIam",
      hasPanTilt: boolean,
      hasRecordVideo: boolean,
      hasZoom: boolean,
      keyFrame: string,
      panTiltIP: string,
      panTiltType?: string | null,
      protocol: string,
      recentFrame: string,
      rtspHost: string,
      sourceVideo: string,
      signedUrlKeyFrame?: string | null,
      signedUrlRecentFrame?: string | null,
    },
    currentPosition?:  {
      __typename: "CurrentPosition",
      pan: string,
      tilt: string,
      zoom?: string | null,
    } | null,
    healthData:  {
      __typename: "DeviceHealthDataIam",
      isOnline: boolean,
      lastAlive: string,
    },
  } | null,
};

export type ListenToServiceHealthDataSubscriptionVariables = {
  customerId: string,
};

export type ListenToServiceHealthDataSubscription = {
  listenToServiceHealthData?:  {
    __typename: "ServiceIam",
    nodeId?: string | null,
    customerId?: string | null,
    locationId?: string | null,
    deviceId?: string | null,
    serviceType?: string | null,
    configuration?: string | null,
    id?: string | null,
    healthData?: string | null,
    isRunning?: boolean | null,
  } | null,
};

export type ListenToEdgeClientMessageSubscriptionVariables = {
  id?: string | null,
};

export type ListenToEdgeClientMessageSubscription = {
  listenToEdgeClientMessage:  {
    __typename: "EdgeClientMessageResponse",
    id: string,
    statusCode: number,
    topic: string,
    payload: string,
    payloadType: PayloadType,
    timestamp: string,
  },
};

export type ListenToUpdateZoneSubscriptionVariables = {
  id?: string | null,
};

export type ListenToUpdateZoneSubscription = {
  listenToUpdateZone?:  {
    __typename: "Zone",
    id: string,
    name: string,
    pan: string,
    tilt: string,
    deviceId: string,
    status: boolean,
    serviceId?: string | null,
    inspectTime?: string | null,
    keyFrame?: string | null,
    threshold?:  {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } | null,
    exclusions?: string | null,
    nodeId: string,
    alertData?: string | null,
    zoom?: string | null,
    shouldNotify?: boolean | null,
    signedUrlKeyFrame?: string | null,
  } | null,
};

export type ListenToDeleteZoneSubscriptionVariables = {
  id?: string | null,
};

export type ListenToDeleteZoneSubscription = {
  listenToDeleteZone?:  {
    __typename: "Zone",
    id: string,
    name: string,
    pan: string,
    tilt: string,
    deviceId: string,
    status: boolean,
    serviceId?: string | null,
    inspectTime?: string | null,
    keyFrame?: string | null,
    threshold?:  {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } | null,
    exclusions?: string | null,
    nodeId: string,
    alertData?: string | null,
    zoom?: string | null,
    shouldNotify?: boolean | null,
    signedUrlKeyFrame?: string | null,
  } | null,
};

export type ListenToAddZoneSubscriptionVariables = {
  customerId?: string | null,
};

export type ListenToAddZoneSubscription = {
  listenToAddZone?:  {
    __typename: "Zone",
    id: string,
    name: string,
    pan: string,
    tilt: string,
    deviceId: string,
    status: boolean,
    serviceId?: string | null,
    inspectTime?: string | null,
    keyFrame?: string | null,
    threshold?:  {
      __typename: "ZoneThreshold",
      id: string,
      name: string,
      value: number,
    } | null,
    exclusions?: string | null,
    nodeId: string,
    alertData?: string | null,
    zoom?: string | null,
    shouldNotify?: boolean | null,
    signedUrlKeyFrame?: string | null,
  } | null,
};

export type ListenToNodeOnlineStatusSubscriptionVariables = {
  customerId: string,
};

export type ListenToNodeOnlineStatusSubscription = {
  listenToNodeOnlineStatus?:  {
    __typename: "NodeIam",
    customerId?: string | null,
    locationId?: string | null,
    id?: string | null,
    nodeName?: string | null,
    nodeId?: string | null,
    level?: NodeLevel | null,
    referenceId?: string | null,
    devices?:  Array< {
      __typename: "Device",
      customerId: string,
      locationId: string,
      locationName?: string | null,
      id: string,
      name: string,
      status?: string | null,
      nodeId: string,
      nodeName?: string | null,
      makeModelId: string,
      cameraIpAddress?: string | null,
      deviceData:  {
        __typename: "DeviceData",
        hasPanTilt: boolean,
        hasRecordVideo: boolean,
        hasZoom: boolean,
        keyFrame: string,
        panTiltIP: string,
        panTiltType?: string | null,
        protocol: string,
        recentFrame: string,
        rtspHost: string,
        sourceVideo: string,
        signedUrlKeyFrame?: string | null,
        signedUrlRecentFrame?: string | null,
      },
      currentPosition?:  {
        __typename: "CurrentPosition",
        pan: string,
        tilt: string,
        zoom?: string | null,
      } | null,
      healthData:  {
        __typename: "DeviceHealthData",
        lastAlive: string,
        isOnline: boolean,
      },
      skuNumber?: string | null,
      configurationName?: string | null,
      serialNumber?: string | null,
      componentSerialNumber?: string | null,
      onboardedAt?: number | null,
    } > | null,
    serviceData?: string | null,
    deviceData?: string | null,
    onboardCommand?: string | null,
    tags?:  Array< {
      __typename: "Tag",
      id: string,
      tagName: string,
    } | null > | null,
    nodeIP?: string | null,
    isOnline?: boolean | null,
  } | null,
};

export type ListenToHumanValidationEventsSubscription = {
  listenToHumanValidationEvents?:  {
    __typename: "HumanValidationEvent",
    id: string,
    customerId: string,
    locationId: string,
    nodeId: string,
    serviceId: string,
    data?: string | null,
    validationState?: ValidationState | null,
    validated_by?: string | null,
    explanation?: string | null,
    eventTime: string,
    audited_by?: string | null,
    transitionInfo?: string | null,
    auditorsExplanation?: string | null,
  } | null,
};

export type ListenToLoaderProgressSubscriptionVariables = {
  jobId: string,
};

export type ListenToLoaderProgressSubscription = {
  listenToLoaderProgress?:  {
    __typename: "LoaderProgress",
    jobId: string,
    percent: number,
    page?: number | null,
    rowsTotal?: number | null,
    message?: string | null,
  } | null,
};
